import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Http, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { MatDialog, MatDialogRef } from "@angular/material";
import { LoadingModalComponent } from 'app/modals/loading-modal/loading-modal.component';
import { ImgPreviewerComponent } from 'app/modals/img-previewer/img-previewer.component';
import * as _ from 'lodash';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { takeUntil } from 'rxjs/operators';
import { Subject, Subscriber } from 'rxjs';
import { PageTitleService } from './core/page-title/page-title.service';
// import { IndexedDbStorageService } from './indexed-db-storage.service';
import { compress, decompress } from 'compress-json';
// import { MainComponent } from './main/main.component';
import * as moment from 'moment';
import { environment } from 'environments/environment';
import { PrepaidServicesService } from './prepaid-services.service';
moment().format();

declare const navigator: any;

@Injectable()
export class SharedDataService {
  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  public apiUrl: string;
  // public school_color = 'var(--schcol, #c5c5c5)';
  private devApiUrl: string;
  public currentWindowWidth: number;
  public httpsDevApiUrl: string;
  public prodApiUrl: string;
  private localApiUrl: string;
  public quoteAPIurl: string = 'https://api.api-ninjas.com/v1/quotes?category=';
  public quoteAPIkey: string = 'Inr2GK1YIeoPlF8fYZlknA==b5oCjH8Ybi9Z0qkV';
  private prodBckupApiUrl: string;
  public wholeSchoolStudents: any = [];
  public classroomChangeReason: any = ['Student Promotion', 'Classroom Stream Change', 'Human Error'];
  public showError = false;
  public loadingBarColor = '#ebeb00';
  public getSchoolCurrenciesCollection = [];
  public getSchoolInvoiceItemsCollection = [];
  public homepageData: any = [];
  public UIs: any = [];
  public exTime;
  public inTime;
  public payTime;
  public timeCycles = ['monthly', 'quarterly', 'yearly'];
  public logo;
  public phone;
  public website;
  public schoolBranches: any = [];
  public checkedForBranches: boolean;
  public checkedForClassrooms: boolean;
  public isScreenRefreshed: boolean = true;
  public checkedForAuthBy: boolean;
  public checkedForTerms: boolean;
  public checkedForCourses: boolean;
  public checkedForPopulation: boolean;
  public checkedForStudents: boolean;
  public checkedForResponsiblePersons: boolean;
  public checkedForTeachers: boolean;
  public checkedForMeds: boolean;
  public checkedForStaff: boolean;
  public checkedForEmployees: boolean;
  public checkedForGroups: boolean;
  public checkedForAsses: boolean;
  public checkedForAssCats: boolean;
  public staleData: boolean;
  public checkedForAnalytics: boolean;
  public checkedForExpenses: boolean;
  public checkedForRevenue: boolean;
  public checkedForAppUser: boolean;
  public checkedForBankAccounts: boolean;
  public checkedForCreatedBy: boolean;
  public checkedForCurrencies: boolean;
  public authoriseByPersonnel: any = [];
  public schoolAccountTypes: any = [];
  public revenueAccountTypes: any = [];
  public checkedForInvoiceItems: boolean;
  public schoolTerms: any = [];
  public InventoryItemsCookie: any = [];
  public schoolClassrooms: any = [];
  public schoolCourses: any = [];
  public classPopulation: any = [];
  public schoolPopulation: any = [];
  public inactiveStudents: any = [];
  public StudentsProfile: any = [];
  public schoolTeachers: any = [];
  public schoolStaff: any = [];
  public schoolEmployees: any = [];
  public schoolGroups: any = [];
  public schoolMedConditions: any = [];
  public assTypes: any = [];
  public assCategories: any = [];
  public schoolAnalytics: any = [];
  public schoolExpenses: any = [];
  public schoolRevenue: any = [];
  public schoolBankAccounts: any = [];
  public schoolCreatedBy: any = [];
  public locationSub = 'Unspecified Location';
  public tokenInformationServe;
  public GESfilesCache = [];
  public houseHolds = [];
  public sessionStorage
  public cacheCompleteValue = 0;
  public curType = ['IGCSE', 'Cambridge', "Côte d\'Ivoire Education System", 'Ghana Education Service (GES/NaCCA)', 'IB Curriculum', 'Montessori', 'Montessori Plus', 'Multiple Curriculums', 'Nigeria Basic Education Curriculum (BEC/UBE)', 'Pearson Edexcel', 'Custom Curriculum', 'Other Curriculum']
  public gls = ["Kindergarten", "Nursery", "Primary", "Lower Primary", "JHS", "Secondary", "Tertiary"]

  public nameForm = [
    "First Name - Middle Name - Last Name",
    "First Name - Last Name - Middle Name",
    "Last Name - Middle Name - First Name",
    "Last Name - First Name - Middle Name"
  ];
  public nameSort = [
    "First Name (Ascending)",
    "Last Name (Ascending)",
    "First Name (Descending)",
    "Last Name (Descending)"
  ];
  public tokenInformationData;
  public schoolInformationData;
  public loginEmail = '';

  public employee_Id;
  // public employee_type;
  public simsred = '#f54b5e';
  public simsgreen = '#78E08F';

  public employee_has_no_branch = false;
  public employeeBranches = [];
  public selectedEmployeeBranch: any;
  public modeOfPayments = ['Bank Deposit(Cash)','Bank Deposit(Cheque)','Bankers Draft', 'Bank Transfer', 'Cash','Cheque','POS', 'Mobile Money(OFFLINE)'];
  public offlinePaymentModesList = [
    { Payment_Service_Provider_Name: 'Bank Deposit(Cash)', Payment_Service_Display_Name: 'Bank Deposit(Cash)' },
    { Payment_Service_Provider_Name: 'Bank Deposit(Cheque)', Payment_Service_Display_Name: 'Bank Deposit(Cheque)' },
    { Payment_Service_Provider_Name: 'Bankers Draft', Payment_Service_Display_Name: 'Bankers Draft' },
    { Payment_Service_Provider_Name: 'Bank Transfer', Payment_Service_Display_Name: 'Bank Transfer' },
    { Payment_Service_Provider_Name: 'Cash', Payment_Service_Display_Name: 'Cash' },
    { Payment_Service_Provider_Name: 'Cheque', Payment_Service_Display_Name: 'Cheque' },
    { Payment_Service_Provider_Name: 'POS', Payment_Service_Display_Name: 'POS' },
    { Payment_Service_Provider_Name: 'Mobile Money(OFFLINE)', Payment_Service_Display_Name: 'Mobile Money(OFFLINE)' },
  ];
  public backCompatActive:boolean = true;
  public useLegacyCalculation = true;

   public releaseVersion = '2.1.3';
   constructor (
    public http: Http,
    private dialog: MatDialog,
    private alertdialog: MatDialog,
    private pageTitleService: PageTitleService,
    private router: Router,
    // private mainComponent: MainComponent,
    // public IndexedDbStore: IndexedDbStorageService,
    public snackBar: MatSnackBar,

  ) {

    this.prodBckupApiUrl = 'https://prodbkup.infoviewsims.com';
    this.prodApiUrl = 'https://prod.infoviewsims.com';
    this.httpsDevApiUrl = 'https://dev.infoviewsims.com';
    this.localApiUrl = 'http://localhost:3000';
    this.apiUrl = this.prodApiUrl;
    this.initializeIdleTimeCounter()
  }

  public set token(v: string) {
    sessionStorage.setItem('token', v);
  }

  public get windowSize() {
    return window.innerWidth;
  }

  public get token(): string {
    return sessionStorage.getItem('token');
  }

  public set school_id(v: any) {
    sessionStorage.setItem('school_id', v);
  }

  public get school_id(): any {
    return sessionStorage.getItem('school_id');
  }

  public set school_name(v: string) {
    sessionStorage.setItem('school_name', v);
  }

  public get school_name(): string {
    return sessionStorage.getItem('school_name');
  }

  public set school_email(v: string) {
    sessionStorage.setItem('school_email', v);
  }

  public get school_email(): string {
    return sessionStorage.getItem('school_email');
  }

  public set school_color(v: string) {
    sessionStorage.setItem('school_color', v);
  }

  public get school_color(): string {
    return sessionStorage.getItem('school_color');
  }

  public set school_color2(v: string) {
    sessionStorage.setItem('school_color2', v);
  }

  public get school_color2(): string {
    return sessionStorage.getItem('school_color2');
  }

  public set user_id(v: string) {
    sessionStorage.setItem('user_id', v);
  }

  public set emp_Id(v: string) {
    sessionStorage.setItem('employee_Id', v);
  }

  public get emp_Id(): string {
    return sessionStorage.getItem('employee_Id');
  }
  public set school_emp_Id(v: string) {
    sessionStorage.setItem('employee_Id', v);
  }

  public get school_emp_Id(): string {
    return sessionStorage.getItem('employee_Id');
  }

  public set splashMessage(v: string) {
    sessionStorage.setItem('splashMessage', v);
  }

  public get splashMessage(): string {
    return sessionStorage.getItem('splashMessage');
  }

  public set role_name(v: string) {
    sessionStorage.setItem('role_name', v);
  }

  public get role_name(): string {
    return sessionStorage.getItem('role_name');
  }

  public set employee_type(v: string) {
    sessionStorage.setItem('employee_type', v);
  }

  public get employee_type(): string {
    return sessionStorage.getItem('employee_type');
  }

  public set mobile_phone_number_1(v: string) {
    sessionStorage.setItem('mobile_phone_number_1', v);
  }

  public get login_email(): string {
    return sessionStorage.getItem('login_email');
  }

  public set login_email(v: string) {
    sessionStorage.setItem('login_email', v);
  }

  public get mobile_phone_number_1(): string {
    return sessionStorage.getItem('mobile_phone_number_1');
  }

  public set user_full_name(v: string) {
    sessionStorage.setItem('user_full_name', v);
  }

  public get user_full_name(): string {
    return sessionStorage.getItem('user_full_name');
  }

  public set windows_url(v: string) {
    sessionStorage.setItem('windows_url', v);
  }

  public get windows_url(): string {
    return sessionStorage.getItem('windows_url');
  }

  public set app_versions(v: Object) {
    sessionStorage.setItem('app_version', JSON.stringify(v));
  }

  public get app_versions(): Object {
    const v = sessionStorage.getItem('app_version');
    return JSON.parse(v);
  }

  public set roles(v) {
    sessionStorage.setItem('roles', JSON.stringify(v));
  }

  public get roles() {
    return sessionStorage.getItem('roles');
  }

  public get apiusersNames() {
    return sessionStorage.getItem('schoolAppUser');
  }
  public set apiusersNames(v) {
    sessionStorage.setItem('schoolAppUser', v)
  }

  public get school_agreement() {
    let returnedAgreements = sessionStorage.getItem('school_agreement');
    if (returnedAgreements) {
      returnedAgreements = decompress(JSON.parse(returnedAgreements));
      // 
    }
    return returnedAgreements ? JSON.stringify(returnedAgreements) : null;
  }
  public set school_agreement(v) {
    let compressedting = compress(JSON.parse(v));
    sessionStorage.setItem('school_agreement', JSON.stringify(compressedting));
  }


  public get school_prepaid_services() {
    let returnedPrepaid = sessionStorage.getItem('school_prepaid_services');
    if (returnedPrepaid) {
      returnedPrepaid = decompress(JSON.parse(returnedPrepaid));
      // 
    }
    return returnedPrepaid ? JSON.stringify(returnedPrepaid) : null;
  }
  public set school_prepaid_services(v) {
    let compressedting = compress(JSON.parse(v));
    sessionStorage.setItem('school_prepaid_services', JSON.stringify(compressedting));
  }

  public set activeSchoolStudents(v: any) {
    // NO COMPRESSION
    // // this.IndexedDbStore.AddtoStore('activeSchoolStudents' + this.school_id, v);
    // sessionStorage.setItem('activeSchoolStudents', v);


    // COMPRESSION
    let compressedting = compress(JSON.parse(v));
    sessionStorage.setItem('activeSchoolStudents', JSON.stringify(compressedting));
  }

  public get activeSchoolStudents() {
    // NO COMPRESSION
    // return sessionStorage.getItem('activeSchoolStudents');

    // COMPRESSION
    let returnedStudents = sessionStorage.getItem('activeSchoolStudents');
    if (returnedStudents) {
      returnedStudents = decompress(JSON.parse(returnedStudents));
      // 
    }
    return returnedStudents ? JSON.stringify(returnedStudents) : null;
  }

  // async activeSchoolStudentsIndexed () {
  //   let whatToReturn = null;
  //   if (sessionStorage.getItem('activeSchoolStudents')) {
  //     whatToReturn = sessionStorage.getItem('activeSchoolStudents');
  //   } else {
  //     await this.IndexedDbStore.getStore('activeSchoolStudents' + this.school_id).then(
  //       item => {
  //         whatToReturn = JSON.stringify(item);
  //       }
  //     );
  //   }
  //   
  //   return whatToReturn;
  // }


  public set duplicateSchoolStudents(v) {
    // NO COMPRESSION
    // // this.IndexedDbStore.AddtoStore('duplicateSchoolStudents',v)
    // sessionStorage.setItem('duplicateSchoolStudents', v);

    // COMPRESSION
    let compressedting = compress(JSON.parse(v));
    sessionStorage.setItem('duplicateSchoolStudents', JSON.stringify(compressedting));
  }

  public get duplicateSchoolStudents() {
    // NO COMPRESSION
    // return sessionStorage.getItem('duplicateSchoolStudents');

    // COMPRESSION
    let returnedStudents = sessionStorage.getItem('duplicateSchoolStudents');
    if (returnedStudents) {
      returnedStudents = decompress(JSON.parse(returnedStudents));
      // 
    }
    return returnedStudents ? JSON.stringify(returnedStudents) : null;
  }

  public set schoolResponsiblePersonsCache(v) {
    sessionStorage.setItem('schoolResponsiblePersons', v);
  }

  public get schoolResponsiblePersonsCache() {
    return sessionStorage.getItem('schoolResponsiblePersons')
  }

  public set schoolTermsCache(v) {
    sessionStorage.setItem('schoolTerms', JSON.stringify(v));
  }

  public get schoolTermsCache() {
    return sessionStorage.getItem('schoolTerms');
  }

  public set schoolEmployeesCache(v) {
    // NO COMPRESSION
    // sessionStorage.setItem('schoolEmployees', v);

    // COMPRESSION
    let compressedting = compress(JSON.parse(v));
    sessionStorage.setItem('schoolEmployees', JSON.stringify(compressedting));
  }

  public get schoolEmployeesCache() {
    // NO COMPRESSION
    // return sessionStorage.getItem('schoolEmployees');

    // COMPRESSION
    let returnedEmployees = sessionStorage.getItem('schoolEmployees');
    if (returnedEmployees) {
      returnedEmployees = decompress(JSON.parse(returnedEmployees));
    }
    return returnedEmployees ? JSON.stringify(returnedEmployees) : null;
  }

  public set schoolStaffCache(v) {
    // NO COMPRESSION
    // sessionStorage.setItem('schoolStaff', v);

    // COMPRESSION
    let compressedting = compress(JSON.parse(v));
    sessionStorage.setItem('schoolStaff', JSON.stringify(compressedting));
  }

  public get schoolStaffCache() {
    // NO COMPRESSION
    // return sessionStorage.getItem('schoolStaff');

    // COMPRESSION
    let returnedEmployees = sessionStorage.getItem('schoolStaff');
    if (returnedEmployees) {
      returnedEmployees = decompress(JSON.parse(returnedEmployees));
    }
    return returnedEmployees ? JSON.stringify(returnedEmployees) : null;
  }

  public set schoolTeachersCache(v) {
    // NO COMPRESSION
    // sessionStorage.setItem('schoolTeachers', v);

    // COMPRESSION
    let compressedting = compress(JSON.parse(v));
    sessionStorage.setItem('schoolTeachers', JSON.stringify(compressedting));
  }

  public get schoolTeachersCache() {
    // NO COMPRESSION
    // return sessionStorage.getItem('schoolTeachers');

    // COMPRESSION
    let returnedEmployees = sessionStorage.getItem('schoolTeachers');
    if (returnedEmployees) {
      returnedEmployees = decompress(JSON.parse(returnedEmployees));
    }
    return returnedEmployees ? JSON.stringify(returnedEmployees) : null;
  }

  public set schoolCoursesCache(v) {
    sessionStorage.setItem('schoolCourses', v);
  }

  public get schoolCoursesCache() {
    return sessionStorage.getItem('schoolCourses');
  }

  public set schoolClassroomsCache(v) {
    sessionStorage.setItem('schoolClassrooms', v);
  }

  public get schoolClassroomsCache() {
    return sessionStorage.getItem('schoolClassrooms');
  }

  public set schoolGroupsCache(v) {
    sessionStorage.setItem('schoolGroups', v);
  }

  public get schoolGroupsCache() {
    return sessionStorage.getItem('schoolGroups');
  }

  public set schoolCurrenciesCache(v) {
    sessionStorage.setItem('schoolCurrencies', v);
  }

  public get schoolCurrenciesCache() {
    return sessionStorage.getItem('schoolCurrencies');
  }

  public set schoolBillItemsCache(v) {
    sessionStorage.setItem('schoolBillItems', v);
  }

  public get schoolBillItemsCache() {
    return sessionStorage.getItem('schoolBillItems');
  }

  public set schoolBankAccountsCache(v) {
    sessionStorage.setItem('schoolBankAccounts', v);
  }

  public get schoolBankAccountsCache() {
    return sessionStorage.getItem('schoolBankAccounts');
  }

  public set schoolExpenseAccountsCache(v) {
    sessionStorage.setItem('schoolExpenseAccounts', v);
  }

  public get schoolExpenseAccountsCache() {
    return sessionStorage.getItem('schoolExpenseAccounts');
  }

  public set schoolRevenueAccountsCache(v) {
    sessionStorage.setItem('schoolRevenueAccounts', v);
  }

  public get schoolRevenueAccountsCache() {
    return sessionStorage.getItem('schoolRevenueAccounts');
  }

  public set schoolAuthCache(v) {
    sessionStorage.setItem('schoolAuth', v);
  }

  public get schoolAuthCache() {
    return sessionStorage.getItem('schoolAuth');
  }

  public set schoolMedConCache(v) {
    sessionStorage.setItem('schoolMedCon', v);
  }

  public get schoolMedConCache() {
    return sessionStorage.getItem('schoolMedCon');
  }

  public set schoolAssTypesCache(v) {
    sessionStorage.setItem('schoolAssTypes', v);
  }

  public get schoolAssTypesCache() {
    return sessionStorage.getItem('schoolAssTypes');
  }

  public set schoolCache(v) {
    sessionStorage.setItem('schoolInfo', v);
  }

  public get schoolCache() {
    return sessionStorage.getItem('schoolInfo');
  }

  public set userCache(v) {
    sessionStorage.setItem('userInfo', v);
  }

  public get userCache() {
    return sessionStorage.getItem('userInfo');
  }

  public set schoolBranchesCache(v) {
    sessionStorage.setItem('schoolBranches', v);
  }

  public get schoolBranchesCache() {
    return sessionStorage.getItem('schoolBranches');
  }

  public set fullSchoolBranchesCache(v) {
    sessionStorage.setItem('schoolBranchesFull', v);
  }

  public get fullSchoolBranchesCache() {
    return sessionStorage.getItem('schoolBranchesFull');
  }

  public set schoolEmployeeBranchesCache(v) {
    sessionStorage.setItem('schoolEmployeeBranches', v);
  }

  public get schoolEmployeeBranchesCache() {
    return sessionStorage.getItem('schoolEmployeeBranches');
  }

  public set schoolServiceProvidersCache(v) {
    sessionStorage.setItem('schoolServiceProviders', v);
  }

  public get schoolServiceProvidersCache() {
    return sessionStorage.getItem('schoolServiceProviders');
  }

  public set schoolFinCreatedByCache(v) {
    sessionStorage.setItem('schoolFinCreatedBy', v);
  }

  public get schoolFinCreatedByCache() {
    return sessionStorage.getItem('schoolFinCreatedBy');
  }

  public set cacheComplete(v) {
    sessionStorage.setItem('cacheComplete', v);
  }

  public get cacheComplete() {
    return sessionStorage.getItem('cacheComplete');
  }

  public set profileImage(v) {
    sessionStorage.setItem('profileImage', v);
  }

  public get profileImage() {
    return sessionStorage.getItem('profileImage');
  }

  public set myMessages(v) {
    sessionStorage.setItem('messageInbox', v);
  }

  public get myMessages() {
    return sessionStorage.getItem('messageInbox');
  }

  public set myPayslips(v) {
    sessionStorage.setItem('payslips', v);
  }

  public get myPayslips() {
    return sessionStorage.getItem('payslips');
  }

  public get user_id(): string {
    return sessionStorage.getItem('user_id');
  }

  public set address_line_1(v: string) {
    sessionStorage.setItem('address_line_1', v);
  }

  public get address_line_1(): string {
    return sessionStorage.getItem('address_line_1');
  }

  public set category_description(v: string) {
    sessionStorage.setItem('category_description', v);
  }

  public get category_description(): string {
    return sessionStorage.getItem('category_description');
  }

  public set category_option(v: string) {
    sessionStorage.setItem('category_option', v);
  }

  public get category_option(): string {
    return sessionStorage.getItem('category_option')
  }

  public set city(v: string) {
    sessionStorage.setItem('city', v);
  }

  public get city(): string {
    return sessionStorage.getItem('city');
  }

  public set country(v: string) {
    sessionStorage.setItem('country', v);
  }

  public get country(): string {
    return sessionStorage.getItem('country');
  }

  public set created_by(v: string) {
    sessionStorage.setItem('user_id', v);
  }

  public get created_by(): string {
    return sessionStorage.getItem('user_id');
  }

  public set curriculum_type(v: string) {
    sessionStorage.setItem('curriculum_type', v);
  }

  public get curriculum_type(): string {
    return sessionStorage.getItem('curriculum_type');
  }

  public set encoded64BitAuth(v: string) {
    sessionStorage.setItem('encoded64BitAuth', v);
  }

  public get encoded64BitAuth(): string {
    return sessionStorage.getItem('encoded64BitAuth');
  }

  public set userLocation(v: string) {
    sessionStorage.setItem('userLocation', v);
  }

  public get userLocation(): string {
    return sessionStorage.getItem('userLocation');
  }

  public set tokenInformation(v: any) {
    let tempSplash = this.apiUrl == this.httpsDevApiUrl ? 'You Think It, We Code It.' : 'Hello, \rin case you need help or support, post it on your InfoView WhatsApp page.\rThanks.'
    this.token = v.token;
    this.mobile_phone_number_1 = v.Mobile_Phone_Number_1;
    this.role_name = Array.isArray(v.Role_Name) ? v.Role_Name[0].Role_Name : v.Role_Name;
    //this.school_id = v.School_Identifier;
    this.user_id = v.User_Identifier;
    if (v.Employee) {
      if (v.Employee.length) {
        this.emp_Id = v.Employee[0].School_Employee_Identifier;
        this.employee_Id = v.Employee[0].School_Employee_Identifier;
        this.employee_type = v.Employee[0].Teaching_Staff_Indicator ? 'teacher' : 'staff';
      }
    }
    this.splashMessage = v.Splash_Message == null ? tempSplash : v.Splash_Message;
    this.user_full_name = v.User_Full_Name;
    this.windows_url = v.Windows_URL;
    this.app_versions = v.app_versions;
    // this.roles = v.roles;
  }

  _opened = true
  toggleOpened() {
    this._opened = !this._opened
  }

  public set schoolInformation(v: any) {
    v.School_Identifier.forEach(school_data => {
      this.school_name = school_data.School_Name;
      this.school_email = school_data.General_Email || school_data.School_Email;
      this.school_id = school_data.School_Identifier;
    });
  }

  public getSchoolID() {
    const id = sessionStorage.getItem('school_id');
    return id;
  }

  public getAuthFromLocal() {
    return this.token;
  }

  public isUserAuthenticated() {
    return this.token == null || this.token == ''
      ? false
      : true;
  }

  public dynamicGET(api): Observable<any> {
    let url = this.apiUrl + api;
    return this.http.get(url, this.returnRequestOptions());
    // .subscribe(
    //   res =>{
    //     this.celebrate('got it');
    //   },
    //   err => {
    //     this.celebrate('dont got it');
    //   }
    // );
  }

  public targetUI;
  public reloadingCurrencies = false;
  public getSchoolCurrencies() {
    this.reloadingCurrencies = true;
    this.getSchoolCurrenciesCollection = [];
    const getCurrenciesBySchool = this.apiUrl + '/transaction/currencies?school_id=' + this.school_id;
    this.http.get(getCurrenciesBySchool, this.returnRequestOptions()).subscribe(
      (res) => {
        let result = res.json();
        result = Array.isArray(result) ? result : [];
        this.pushToCollection(result, this.getSchoolCurrenciesCollection); this.checkedForCurrencies = true;
        this.schoolCurrenciesCache = JSON.stringify([...result]);
        this.reloadingCurrencies = false;
        this.cacheCompleteValue += 10;
      },
      (err) => {
        // this.celebrate('We could not get your school currencies,Please check your internet connection ', 'Okay');
        this.reloadingCurrencies = false;
        this.cacheCompleteValue += 10;
      }
    );
  }

  public reloadingSPs = false;
  public getServiceProviders() {
    this.reloadingSPs = true;
    const getSPs = this.apiUrl + '/service_provider?school_id=' + this.school_id + '&status=active&pass_credit=1&detail=1';

    this.http.get(getSPs, this.returnRequestOptions()).subscribe(
      (res) => {
        // var tempSPs = res.json();
        this.schoolServiceProvidersCache = JSON.stringify([...res.json()]);
        this.reloadingSPs = false;
        // tempSPs.forEach((sp) => {
        //   this.modeOfPayments.push(sp.Payment_Service_Provider_Name+"(ONLINE)");
        // });
        this.cacheCompleteValue += 10;
      },
      (err) => {
        // let message  =  err._body.toString();
        // this.celebrate(message, 'Okay');
      }
    );

  }

  public getSchoolInvoiceItems() {
    const getSchoolInvoiceItems = this.apiUrl + '/transaction/school_invoice_items?school_id=' + this.school_id;
    this.getSchoolInvoiceItemsCollection = [];
    this.http.get(getSchoolInvoiceItems, this.returnRequestOptions()).subscribe(
      (res) => {
        let result = Array.isArray(res.json()) ? res.json() : [];
        this.pushToCollection(result, this.getSchoolInvoiceItemsCollection);
        this.checkedForInvoiceItems = true;
        this.schoolBillItemsCache = JSON.stringify([...result]);
        this.cacheCompleteValue += 10;
      },
      (err) => {
        // this.celebrate('We could not get your school invoice items,Please check your internet connection ', 'Okay');
        this.cacheCompleteValue += 10;
      }
    );
  }

  public getSchoolBranches() {
    const getStudentsBySchool = this.apiUrl + '/school/branch?school_id=' + this.school_id;
    this.http.get(getStudentsBySchool, this.returnRequestOptions()).subscribe(
      (res) => {
        let response = res.json()
        if ('message' in res.json()) {
          response = []
          this.checkedForBranches = true
        } else {
          this.schoolBranches = [...res.json()]
          this.schoolBranchesCache = JSON.stringify([...res.json()]);
          this.fullSchoolBranchesCache = JSON.stringify([...res.json()]);
        }
        // this.pushToCollection(res.json(), this.schoolBranches);
        this.checkedForBranches = true;
        this.getEmployeeBranches();
      },
      (err) => {
        this.cacheCompleteValue += 10;
      }
    );

  }

  public getEmployeeBranches() {
    if (this.employee_Id == null) {
      this.employeeBranches = [];
      this.schoolEmployeeBranchesCache = JSON.stringify([]);
      this.employee_has_no_branch = true;
    }
    else {
      const url = this.apiUrl + `/employee_branch?school_employee_id=${this.employee_Id}&type=${this.employee_type}&school_id=${this.school_id}`;
      this.http.get(url, this.returnRequestOptions()).subscribe(
        (res) => {
          let employeeBranches = JSON.parse(res['_body']);
          this.employeeBranches = Array.isArray(employeeBranches) ? employeeBranches : [];
          if (this.employeeBranches.length == 0) {
            this.schoolEmployeeBranchesCache = JSON.stringify(this.schoolBranches);
          }
          else {
            this.schoolEmployeeBranchesCache = JSON.stringify(this.employeeBranches);
            this.schoolBranchesCache = JSON.stringify(this.employeeBranches);
          }
          this.cacheCompleteValue += 10;
        },
        (err) => {
          this.employeeBranches = [];
          this.schoolEmployeeBranchesCache = JSON.stringify(this.schoolBranches);
          this.employee_has_no_branch = true;
          this.cacheCompleteValue += 10;
        }
      );
    }
  }

  public getAccountTypesBySchool() {
    const getAccountTypesBySchool = this.apiUrl + '/school/account_types?school_id=' + this.school_id + '&account_name=expense&all_child=1';
    this.schoolAccountTypes = [];
    this.http.get(getAccountTypesBySchool, this.returnRequestOptions()).subscribe(
      (res) => {
        this.pushToCollection(res.json(), this.schoolAccountTypes);
        this.schoolExpenseAccountsCache = JSON.stringify([...res.json()]);
        this.cacheCompleteValue += 10;
      },
      (err) => {
        // this.celebrate('We could not get your school account types,Please check your internet connection ', 'Okay');
        this.cacheCompleteValue += 10;
      }
    );

  }

  getAssTypes() {
    const types = '/child/child_assessment_type?school_id=' + this.school_id;
    this.getHttp(types).subscribe(
      (res) => {
        let asses = Array.isArray(res.json()) ? res.json() : [];
        this.assTypes = asses;
        this.schoolAssTypesCache = JSON.stringify([...res.json()]);
        this.cacheCompleteValue += 10;
      },
      (err) => {
        // this.celebrate('We could not get your Schools Assessment Types,Please check your internet connection ', 'Okay');
        this.cacheCompleteValue += 10;
      }
    );
  }

  public getTeachers() {
    const url = this.apiUrl + '/teacher?' + '&school_id=' + this.school_id;
    this.schoolTeachers = [];
    this.http.get(url, this.returnRequestOptions()).subscribe(
      res => {
        this.schoolTeachers = [...res.json()]
        // this.pushToCollection(res.json(), this.schoolTeachers);
        this.checkedForTeachers = true;
      },
      err => {
        const error = err.json();
        error.message == 'No data found' ? this.celebrate("No Teachers Found", "Okay") : this.celebrate("No Teachers Found", "Okay");
      }
    );
  }

  public getAnalytics(start, end) {
    this.schoolAnalytics = [];
    const url = this.apiUrl + '/analytics/financial?school_id=' + this.school_id + '&start_date=' + start + '&end_date=' + end;
    this.http.get(url, this.returnRequestOptions()).subscribe(
      res => {
        this.pushToCollection(res.json(), this.schoolAnalytics);
        this.checkedForAnalytics = true;
      },
      err => {
        const error = err.json();
      }
    );
  }

  public getRevenue(start, end, curr) {
    let billsByDate;
    this.schoolRevenue = [];
    billsByDate = `${this.apiUrl}/transaction/revenue_summary?school_id=${this.school_id}&start_date=${start}&end_date=${end}&pref_curr=${curr}`;
    this.http.get(billsByDate, this.returnRequestOptions()).subscribe(
      (res) => {
        this.pushToCollection(res.json(), this.schoolRevenue);
        this.checkedForRevenue = true;
      },
      (err) => {
        this.celebrate("Could Not get School Revenue", "Okay")
      }
    );
  }

  public getAppuserRec() {
    let userurl = '/user_name?school_id=' + this.school_id
    // this.showSpinner();
    this.getHttp(userurl).subscribe(
      res => {
        // this.closeSpinner();
        let result = Array.isArray(res.json()) ? [...res.json()] : []
        if (!result.length) {
          // this.celebrate('No User Found');
          return
        }
        this.checkedForAppUser = true;
        this.apiusersNames = JSON.stringify(result)

      }, err => {

      }
    )
  }
  public async getSchoolAgreement() {
    if(!this.school_id){
      return
    }
    let aggreementurl = `/school_agreement?school_id=${this.school_id}`
    let res = await this.httpGetAsync(aggreementurl);

    if (res.status == 200) {
      let result = Array.isArray(res.json()) ? [...res.json()] : []
      if (!result.length) {
        // this.celebrate('No User Found');
        return
      }
      // this.checkedForAppUser = true;
      this.school_agreement = JSON.stringify(result)
      let showModal = false
      result = result.sort((a, b) => moment(a.Service_Package_Expiration_Date).diff(moment(b.Service_Package_Expiration_Date)));
      // if(result.every(item=>moment(item.Service_Package_Expiration_Date).isBefore(moment(), 'day'))){
      //   showModal=true
      // }else 
      if(moment(result[0].Service_Package_Expiration_Date).isBefore(moment(), 'day') && result[0].Service_Base_Package_Type=="Prepaid"){
        showModal = true
      }

      if(showModal){
        if (!sessionStorage.getItem('ExpiredSchoolAgreement')) {
          sessionStorage.setItem('ExpiredSchoolAgreement', 'true');
          setTimeout(() => {
            this.alertRef = this.alertdialog.open(LoadingModalComponent, {
              width: "68%",
              disableClose: true,
              data: {
                type: "prepaid",
                title: '',
                message: '',
                confirm: "Renew Agreement",
                close: "Cancel",
                cancel_action: () => {this.alertRef.close(); this.alertRef = undefined },
                confirm_action: () => { this.router.navigate(['/school-subscriptions/subscriptions'],{queryParams:{"renewal":true}}); this.alertRef.close(); this.alertRef = undefined },
                cancel_text_normal: '',
                // assInnerHTML: asInnerHTML
              }
            })
          }, 2000);    
        }
      }
    } else {
      this.noAgreementAlert();  
    }
  }

  public noAgreementAlert(){
    this.showAlert(
      'Not Authorized',
      "It seems you are not authorized to access your school's subscription.<br>Please contact your administrator to grant you this access before you can use the app.",
      () => {
        this.router.navigate(['/login']);
      },
      () => {},
      "Okay"
    );
  }

  public async  getSchoolPrepaidServices() {
    this.isScreenRefreshed = false;
    let tokenData = sessionStorage.getItem('tokenInfo');
    let userEmployeeId = tokenData ? JSON.parse(tokenData) : null
    if (!userEmployeeId) {
      return
    }

    let prepaidServices = `/micro_pricing/prepaid_service_transaction?school_id=${this.school_id}&school_employee_id=${this.school_emp_Id}&status=Completed,Pending&expiration=nonexpired`
   await this.getHttp(prepaidServices).toPromise().then(
      res => {
        let result = Array.isArray(res.json()) ? [...res.json()] : []
        if (!result.length) {
          // this.celebrate('No User Found');
          this.school_prepaid_services = JSON.stringify(result)
          return
        }
        // this.checkedForAppUser = true;
        this.school_prepaid_services = JSON.stringify(result)
      }
    )
  }

  getExpenses(start, end) {
    let getExpensesUrl;
    this.schoolExpenses = [];
    getExpensesUrl = `${this.apiUrl}/school/expenses?school_id=${this.school_id}&start_date=${start}&end_date=${end}`;
    this.http.get(getExpensesUrl, this.returnRequestOptions()).subscribe(
      (res) => {
        this.pushToCollection(res.json(), this.schoolExpenses);
        this.checkedForExpenses = true;
      },
      (err) => {
        this.celebrate("Could not get Expenses", "Okay")
      }
    );
  }

  getRevenueAccountType(): void {
    const revenueAccountTypeUrl = this.apiUrl + '/school/account_types?school_id=' + this.school_id + '&account_name=revenue&all_child=1' + this.getActivityForUrl();
    this.revenueAccountTypes = [];
    this.http.get(revenueAccountTypeUrl, this.returnRequestOptions()).subscribe(
      (res) => {
        let result = res.json();
        result = Array.isArray(result) ? result : [];
        this.pushToCollection(result, this.revenueAccountTypes);
        this.schoolRevenueAccountsCache = JSON.stringify([...result]);
      },
      (err) => {
        // this.celebrate('We could not get your school revenue account types, check your internet connection ', 'Okay');
      }
    );
  }

  getSchoolFinCreatedBy() {
    const url = '/school/financial_createdby?school_id=' + this.school_id;
    this.getHttp(url).subscribe(
      res => {
        var employees = Array.isArray(res.json()) ? res.json() : [];
        employees.forEach(element => {
          element.Frist_Name = element.Frist_Name_User;
          element.Middle_Name = element.Middle_Name_User;
          element.Last_Name = element.Last_Name_User;
        });
        employees = _.sortBy(employees, 'Frist_Name');
        this.schoolFinCreatedByCache = JSON.stringify([...res.json()]);
        this.cacheCompleteValue += 10;
      },
      err => {
        this.cacheCompleteValue += 10;
        // const error = err.json();
        // if (error.message == 'No data found.')
        //   this.celebrate("Cannot get Employees");
      }
    );
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  randomHexColorCode = () => {
    let n = (Math.random() * 0xfffff * 1000000).toString(16);
    return '#' + n.slice(0, 6);
  }

  public showMessage(theM) {
    // Get the snackbar DIV
    var x = document.getElementById("snackbar");
    var i = document.createElement('i');

    i.setAttribute('class', 'fa fa-exclamation-circle');
    i.setAttribute('style', 'padding-left: 5px');

    x.innerHTML = theM;
    x.appendChild(i);

    // Add the "show" class to DIV
    // After 3 seconds, remove the show class from DIV
    x.className = "show";
    setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
  }

  public getStudentPopulation() {
    const url = this.apiUrl + '/student/population?' + '&school_id=' + this.school_id;
    this.classPopulation = [];
    this.schoolPopulation = [];
    this.http.get(url, this.returnRequestOptions()).subscribe(
      res => {
        const pops = res.json();
        this.pushToCollection(pops.Class_Population, this.classPopulation);
        this.pushToCollection(pops.School_Population, this.schoolPopulation);
        this.checkedForPopulation = true;;
      },
      err => {
        const error = err.json();
        error.message == 'No data found' ? this.celebrate("No data Found", "Okay") : this.celebrate("No data Found", "Okay");
      }
    );
  }

  mergePDF(addedBody) {
    const url = this.apiUrl + '/utility/merge_pdf'
    const body = {
      "School_Identifier": this.school_id,
      "School_Name": this.school_name,
      "School_Email": this.school_email,
      "User_Identifier": +this.user_id,
      ...addedBody
    }
    return this.http.post(url, body, this.returnRequestOptions())

  }


  async utilityExport(reportName, data, recipient) {

    //validate email
    if (recipient !== "") {
      if (!this.ValidateEmail(recipient)) {
        this.celebrate("Please Enter a valid Email", "Okay");
        return 0;
      }
    }

    let schoolTokenInfo = sessionStorage.getItem('tokenInfo');
    let tokenInfo = JSON.parse(schoolTokenInfo);
    let schoolName = tokenInfo.School_Identifier[0].School_Name;
    let schoolEmail = tokenInfo.School_Identifier[0].Academic_Email || this.school_email;

    var today = new Date();
    let month, day, time;
    month = (today.getMonth() + 1) < 10 ? "0" + (today.getMonth() + 1) : (today.getMonth() + 1);
    day = (today.getDate().toString).length == 1 ? "0" + today.getDate() : today.getDate();
    day = day.toString().length == 3 ? today.getDate() : day.toString();
    day = month.toString().length == 3 ? (today.getMonth() + 1) : day.toString();
    time = day + '-' + month + '-' + today.getFullYear();

    let bodyToPost2 = {
      "School_Identifier": this.school_id,
      "School_Name": schoolName,
      "School_Email": schoolEmail,
      "Recepient_Email": "",
      "Report_Name": reportName + " (" + time + ")",
      "Items": data
    }

    // check if the user has email
    if (recipient == '') {
      bodyToPost2.Recepient_Email = bodyToPost2.School_Email;
    } else {
      bodyToPost2.Recepient_Email = recipient;
    }

    this.showSpinner('Exporting');
    let rez = await this.httpPostAsync('/utility/export_data', bodyToPost2);
    this.closeSpinner();
    if (rez.status == 200) {
      this.celebrate('Data has been sent to your email successfully, please check your email', 'Okay');
    }
    else {
      this.handleErrorMessage(rez);
    }
  }

  /**
   *
   * @param receiverEmail email to receive
   * @param reportName Report name
   * @param items array of data to be sent
   * @param direction, financial (fin),general(gen) or academic(aca) email if none use default school email
   * @returns observable to subscribe to
   */
  exportData(receiverEmail: string, reportName: string, items: any[], direction?: string) {
    const details = this.pageTitleService.title.value.split(' ~ ')
    const url = this.apiUrl + '/utility/export_data' + `?${this.getActivityForUrl(details[0], 'Exporting ' + details[1])}`
    let schoolTokenInfo = sessionStorage.getItem('tokenInfo');
    let tokenInfo = JSON.parse(schoolTokenInfo);

    let email = this.school_email
    if (direction == 'fin') {
      email = tokenInfo.School_Identifier[0].Financial_Email || this.school_email
    }
    if (direction == 'gen') {
      email = tokenInfo.School_Identifier[0].General_Email || this.school_email
    }
    if (direction == 'aca') {
      email = tokenInfo.School_Identifier[0].Academic_Email || this.school_email
    }


    const body = {
      "School_Name": this.school_name,
      "School_Email": email,
      "Recepient_Email": receiverEmail,
      "Report_Name": reportName,
      "Items": [...items]
    }


    return this.http.post(url, body, this.returnRequestOptions())

  }

  //!returns date in dd mmm yyyy eg 01 March 2020
  getDateWithMonthWords(date) {
    return new Date(date).toLocaleString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  }

  /**
   *
   * @param email to be checked
   * @returns true if valid, false if invalid
   */
  checkEmail(email) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
  }

  /**
   *
   * @param num validates numbers that contain only digits and have length greater or equal to 5 (for solomon island requirements)
   * @returns true if valid, false if invalid
   */
  checkPhoneNumber(num) {
    return (/^\d+$/.test(num)) && num.length >= 5
  }

  public getStudentsBySchool() {
    this.wholeSchoolStudents = [];
    const getStudentsBySchool = this.apiUrl + '/student?school_id=' + this.school_id + '&status=active';

    this.http.get(getStudentsBySchool, this.returnRequestOptions()).subscribe(
      (res) => {
        //  this.pushToCollection( res.json(), this.wholeSchoolStudents);
        this.wholeSchoolStudents = [...res.json()]
        this.showError = false; this.checkedForStudents = true;
      },
      (err) => {
        // this.celebrate('We could not get your school students,Please check your internet connection ', 'Okay');
      }
    );

  }

  returnClassroomStudentID(student_id) {
    let schoolStudents = this.activeSchoolStudents ? JSON.parse(this.activeSchoolStudents) : [];
    let student = schoolStudents.find(stdt => stdt.Student_Identifier == parseInt(student_id));
    return student ? student.Classroom_Student_Identifier : null;
  }

  public getSchoolResponsiblePersons() {
    this.http.get(this.apiUrl + `/responsible_person?school_id=${this.school_id}`, this.returnRequestOptions()).subscribe(res => {
      const results = Array.isArray(res.json()) ? _.uniqBy(res.json(), "Person_Identifier") : []
      this.schoolResponsiblePersonsCache = JSON.stringify(results);
    }, error => {
      this.schoolResponsiblePersonsCache = JSON.stringify([]);
    })
  }

  public getSchoolTerms() {
    const getSchoolTerms = this.apiUrl + '/school_term?school_id=' + this.school_id + '&detail=1' + this.getActivityForUrl();

    this.http.get(getSchoolTerms, this.returnRequestOptions()).subscribe(
      (res) => {
        this.pushToCollection(res.json(), this.schoolTerms);
        this.schoolTermsCache = res.json();
        // let ct;
        // this.schoolTerms.forEach(element => {
        //   if (element.Current_Term_Indicator == 1) {
        //     ct = element;
        //   }
        // });
        // this.mainComponent.getPayslips(ct.Begin_Date.substring(0,10), ct.End_Date.substring(0,10));
        this.cacheCompleteValue += 10;
        this.checkedForTerms = true;
      },
      (err) => {
        // this.celebrate('We could not get your school terms,Please check your internet connection ', 'Okay');
        this.cacheCompleteValue += 10;
      }
    );
  }

  public termClassFilter(classesLinked, classrooms) {
    let filteredArray = [];
    if (classesLinked.length == 0) {
      filteredArray = classrooms;
    } else {
      classesLinked.forEach(class_id => {
        classrooms.forEach(classroom => {
          if (class_id.Classroom_Identifier == classroom.Classroom_Identifier) {
            filteredArray.push(classroom);
          }
        });
      });
    }

    filteredArray = this.classfilterAlgo(filteredArray);
    return filteredArray;
  }

  public getSchoolClassrooms() {
    const getSchoolClassrooms = this.role_name !== "Teacher" && this.role_name !== "Class Teacher" ? this.apiUrl + '/classroom?school_id=' + this.school_id + '&detail=1' : this.apiUrl + '/classroom?school_employee_id=' + this.emp_Id + '&detail=1';
    this.schoolClassrooms = [];
    this.http.get(getSchoolClassrooms, this.returnRequestOptions()).subscribe(
      (res) => {
        let classrooms = Array.isArray(res.json()) ? res.json() : [];
        this.pushToCollection(classrooms, this.schoolClassrooms);
        this.checkedForClassrooms = true;
        this.classfilterAlgo(this.schoolClassrooms)
        this.schoolClassroomsCache = JSON.stringify([...classrooms]);
        this.cacheCompleteValue += 10;
      },
      (err) => {
        // this.celebrate('We could not get your school classrooms,Please check your internet connection ', 'Okay');
        this.cacheCompleteValue += 10;
      }
    );
  }

  gradeLevels() {
    let cls = JSON.parse(this.schoolClassroomsCache);
    let distinctGLs = [];
    distinctGLs = cls.map(element => element.Grade_Level);
    distinctGLs = this.getDistinctElement(distinctGLs);
    distinctGLs = _.sortBy(distinctGLs);
    return distinctGLs;
  }

  public getCourses() {
    const url = this.role_name !== "Teacher" && this.role_name !== "Class Teacher" ? this.apiUrl + '/course?' + '&school_id=' + this.school_id : this.apiUrl + '/course?' + '&school_employee_id=' + this.emp_Id;
    this.http.get(url, this.returnRequestOptions()).subscribe(
      res => {
        // this.pushToCollection(res.json(), this.schoolCourses);
        this.schoolCourses = [...res.json()];
        this.schoolCoursesCache = JSON.stringify([...res.json()]);
        this.cacheCompleteValue += 10;
        this.checkedForCourses = true;
      },
      err => {
        this.cacheCompleteValue += 10;
        // error.message == 'No data found' ? this.celebrate("No Courses Found","Okay") : this.celebrate("No Courses Found","Okay");
      }
    );
  }


  public getGroupsInSchool() {
    const url = this.apiUrl + '/school/groups?school_id=' + this.school_id;
    this.http.get(url, this.returnRequestOptions()).subscribe(
      res => {
        let groups = Array.isArray(res.json()) ? res.json() : [];
        groups = _.sortBy(groups, 'Group_Name');
        this.schoolGroups = groups;
        this.schoolGroupsCache = JSON.stringify(groups);
        this.cacheCompleteValue += 10;
      },
      err => {
        this.cacheCompleteValue += 10;
      }
    );
  }

  public reloadingFinancialAccounts = false;
  getCashAccounts() {
    this.reloadingFinancialAccounts = true;
    const url = this.apiUrl + '/school/school_bank_account?school_id=' + this.school_id + this.getActivityForUrl();
    this.http.get(url, this.returnRequestOptions()).subscribe(
      (res) => {
        const cashAccs = Array.isArray(res.json()) ? res.json() : [];
        this.schoolBankAccounts = []
        cashAccs.forEach(account => {
          if (account.Bank_Account_Name == null || account.Bank_Account_Name == "") {
            if (account.Mobile_Money_Number !== null) {
              account.Bank_Account_Name = account.Bank_Name + " - " + account.Mobile_Money_Number;
            }
          }
          if (account.Bank_Name !== null && account.Bank_Name !== "") {
            if (account.Mobile_Money_Number !== null) {
              account.Bank_Account_Name = account.Bank_Name + " - " + account.Mobile_Money_Number;
            }
          }
          this.schoolBankAccounts.push(account);
        });
        this.schoolBankAccountsCache = JSON.stringify(this.schoolBankAccounts);
        this.cacheCompleteValue += 10;
        this.reloadingFinancialAccounts = false;
      },
      (err) => {
        this.cacheCompleteValue += 10;
      }
    );
  }

  getStudentMedics() {
    const url = this.apiUrl + '/medical_condition?school_id=' + this.school_id;
    this.http.get(url, this.returnRequestOptions()).subscribe(
      res => {
        var items = res.json();
        this.checkedForMeds = true;
        this.schoolMedConditions = items;
        this.schoolMedConCache = JSON.stringify(items);
        this.cacheCompleteValue += 10;
      },
      err => {
        this.cacheCompleteValue += 10;
      }
    );
  }

  public getAuthorisedBy() {
    const getAuthorisedBy = '/school/authorized_signature?school_id=' + this.school_id;
    this.authoriseByPersonnel = [];
    this.getHttp(getAuthorisedBy).subscribe(
      (res) => {
        let rez = Array.isArray(res.json()) ? res.json() : [];
        this.pushToCollection(rez, this.authoriseByPersonnel);
        this.checkedForAuthBy = true;
        this.schoolAuthCache = JSON.stringify([...rez]);
        this.cacheCompleteValue += 10;
      },
      (err) => {
        this.cacheCompleteValue += 10;
        // this.celebrate("Sorry Could not get Authorized Persons", "Okay");
      }
    );
  }

  public employeePayrollDetails = [];
  public employeePayrollDetailsCopy = [];
  public employeePayPeriods = [];
  public loadingPayDetails = false;
  getPayrollDetail() {
    this.loadingPayDetails = true;
    this.showSpinner('Loading Payroll Details');
    this.employeePayrollDetails = [];
    this.employeePayrollDetailsCopy = [];
    const url = this.apiUrl + '/payroll/employee_detail?school_id=' + this.school_id + this.getActivityForUrl();
    this.http.get(url, this.returnRequestOptions()).subscribe(
      res => {
        this.closeSpinner();
        var items = res.json();
        items.forEach(element => {
          let employeesArray = JSON.parse(this.schoolEmployeesCache);
          // if (element.Teacher_Identifier !== null) {
          employeesArray.forEach(emp => {
            if (emp.School_Employee_Identifier == element.School_Employee_Identifier) {
              element.Branch_Identifier = emp.Branch_Identifier;
            }
          });
          // }
          // else{
          //   employeesArray.forEach(emp => {
          //     if (emp.Staff_Identifier == element.Staff_Identifier) {
          //       element.Branch_Identifier = emp.Branch_Identifier;
          //     }
          //   });
          // }

          // if (element.Teacher_Identifier == null) {
          if (element.School_Employee_Identifier && element.Base_Monthly_Salary !== null) {
            this.employeePayrollDetails.push(element);
            this.employeePayrollDetailsCopy.push(element);
          }
          // }
          // else {
          //   if (element.Teacher_Identifier !== null && element.Base_Monthly_Salary !== null) {
          //     this.employeePayrollDetails.push(element);
          //     this.employeePayrollDetailsCopy.push(element);
          //   }
          // }
        });
        this.employeePayrollDetails = _.sortBy(this.employeePayrollDetails, 'Teacher_First_Name');
        this.employeePayrollDetailsCopy = _.sortBy(this.employeePayrollDetailsCopy, 'Teacher_First_Name');

        this.loadingPayDetails = false;
      },
      err => {
        this.loadingPayDetails = false;
        this.closeSpinner();
        this.celebrate('Unable to get Payroll Employee details');
      }
    );
  }

  public gottenPayPeriods = false;
  getPayPeriods() {
    if (!this.loadingPayDetails) {
      this.showSpinner('Loading Payroll Periods');
    }
    this.employeePayPeriods = [];
    const url = this.apiUrl + '/payroll/employee_pay_peroids?school_id=' + this.school_id;
    this.http.get(url, this.returnRequestOptions()).subscribe(
      res => {
        this.gottenPayPeriods = true;
        this.closeSpinner();
        var items = res.json();
        items.forEach(element => {
          if (element.Payroll_Begin_Date == null) {
            element.Payroll_Begin_Date = '0000-00-00';
          }
          if (element.Payroll_End_Date == null) {
            element.Payroll_End_Date = '0000-00-00';
          }
        });
        this.employeePayPeriods = _.sortBy(items, 'Payroll_End_Date').reverse();

      },
      err => {
        this.closeSpinner();
        this.celebrate('Unable to get Payroll Employee details');
      }
    );
  }

  ValidateEmail(emailString) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailString)) {
      return (true)
    }
    return (false)
  }

  public getBrowserName() {
    if (this.clientIP == '') {
      this.getIP();
    }
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'Edge' + this.clientIP;
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'Opera' + this.clientIP;
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'Chrome' + this.clientIP;
      case agent.indexOf('trident') > -1:
        return 'IE' + this.clientIP;
      case agent.indexOf('firefox') > -1:
        return 'Firefox' + this.clientIP;
      case agent.indexOf('safari') > -1:
        return 'Safari' + this.clientIP;
      default:
        return 'Other' + this.clientIP;
    }
  }

maplink: any;
public geoError = '';
private returnedLocation;
public positionAllowed:boolean;
public async geoFindMe() {
  navigator.permissions.query({ name: 'geolocation' })
  .then((permissionObj) => {
    
    if (permissionObj.state === 'granted') {
      this.positionAllowed = true;
      navigator.geolocation.getCurrentPosition(function(position) {
        try {
          this.locationSub = position.coords.latitude + ',' + position.coords.longitude;
          this.userLocation = position.coords.latitude + ',' + position.coords.longitude;
        } catch (error) {}
      }, function(err) {
        
      });
    }
    else{
      this.positionAllowed = false;
    }
  })
  .catch((error) => {
    
  });

    // Define a global variable to store the geolocation coordinates
    let globalGeolocation: { latitude: number | null, longitude: number | null } = { latitude: null, longitude: null };
    this.returnedLocation = globalGeolocation;
    // Check if the Geolocation API is supported by the browser
    if (navigator.geolocation) {
      // Use the Geolocation API to get the current position
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // Extract the latitude and longitude from the position object
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;

        // Assign the values to the globalGeolocation variable
        globalGeolocation = { latitude, longitude };
        this.returnedLocation = globalGeolocation;
        this.locationSub = globalGeolocation.latitude + ',' + globalGeolocation.longitude;
        this.userLocation = globalGeolocation.latitude + ',' + globalGeolocation.longitude;
        // Use the globalGeolocation variable as needed
        //
        //
      },
      (error) => {
        
        if (error.code !== 1) {
          this.positionAllowed = true;
        }
        else{
          this.positionAllowed = false;
        }
        // Handle error case
        // console.error('Error getting geolocation:', error);
      }
    );

      setTimeout(() => {

        //
      }, 6000);
    } else {
      // Geolocation API is not supported
      console.error('Geolocation is not supported by this browser.');
    }
  }

  public delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  successExternal(position) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    this.locationSub = `${latitude},${longitude}`;

  }

  private idleTimeout: number = 28800;
  private lastActiveTime: any;
  initializeIdleTimeCounter() {
    this.lastActiveTime = new Date();
    if (this.isScreenRefreshed) {
      this.getSchoolPrepaidServices()
    }
    // window.addEventListener('keydown', this.handleUserActivity);
    window.addEventListener('click', this.handleUserActivity);
  }

  private handleUserActivity = () => {
    // Calculate the difference in seconds
    const secondsDifference = moment(new Date().toJSON()).diff(moment(this.lastActiveTime.toJSON()), 'seconds');

    if (secondsDifference > this.idleTimeout) {
      this.router.navigate(['/login'], { queryParams: { session_timeout: true } });
    }
    else {
      this.lastActiveTime = new Date();
    }
  }

  public returnHeaders() {
    if (this.locationSub == undefined) {

      this.locationSub = this.userLocation ? this.userLocation : 'Unspecified Location';
    }
    else if (this.locationSub == 'Unspecified Location' || this.locationSub == '') {

      this.locationSub = this.userLocation ? this.userLocation : 'Unspecified Location';
    }
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', this.encoded64BitAuth);
    headers.append('x-location', this.locationSub);
    headers.append('x-device-info', this.getBrowserName());

    return headers;
  }

  public returnRequestOptions() {
    const requestOptions = new RequestOptions();
    requestOptions.headers = this.returnHeaders();
    return requestOptions;
  }

  public returnHeaders2() {
    const headers = new Headers();
    headers.append('enctype', 'multipart/form-data');
    headers.append('Authorization', this.encoded64BitAuth);
    headers.append('x-location', this.locationSub);
    headers.append('x-device-info', this.getBrowserName());

    return headers;
  }

  public returnRequestOptions2() {
    const requestOptions = new RequestOptions();
    requestOptions.headers = this.returnHeaders2();
    return requestOptions;
  }


  // *pass array of branches
  //* returns an array of all employees linked to branches that the user is linked to
  //* if there are no branches show all employees
  getBranchFilteredEmployees(branchIds, employeesList = JSON.parse(this.schoolEmployeesCache)) {
    if (!branchIds.length) {
      return employeesList.map(item => item.School_Employee_Identifier)
    }
    return employeesList.filter(item => branchIds.map(item => item.Branch_Identifier).includes(item.Branch_Identifier)).map(item => item.School_Employee_Identifier)
  }

  public pushToCollection(data, where) {

    if (where === this.schoolClassrooms) {

      data.sort(function (a, b) {
        return b.Classroom_Name.toLowerCase() < a.Classroom_Name.toLowerCase();
      });

      data.forEach(oneData => where.push(oneData));
    }
    else if (where === this.wholeSchoolStudents) {
      let students = [];
      let ishere;
      data.forEach(element => {
        if (students.length !== 0) {
          ishere = true;
          students.forEach(element2 => {
            if (element2.Student_Identifier == element.Student_Identifier) { ishere = false; }
          });

          if (ishere) { students.push(element) }
        }
        else { students.push(element); }
      });
      where = students;
      this.wholeSchoolStudents = students
    }
    else {
      if (Array.isArray(data)) {
        data.forEach(oneData => where.push(oneData));
      }
    }

  }

  public clientIP = '';
  fetchingIP = false;
  public async getIP() {
    if (this.fetchingIP) {
      return;
    }

    let ipResponse;
    this.fetchingIP = true;
    if (sessionStorage.getItem('myip')) {
      this.clientIP = sessionStorage.getItem('myip');
      this.fetchingIP = false;
    } else {
      try {
        ipResponse = await this.http.get('https://api64.ipify.org?format=json').toPromise();
        this.clientIP = ipResponse.json().ip;
        sessionStorage.setItem('myip', this.clientIP);
      } catch (error) {
        
      }
      this.fetchingIP = false;
    }
  }

  public getTokenInformation() {
    const tokenUrl = this.apiUrl + '/token?detail=1';

    this.http.get(tokenUrl, this.returnRequestOptions()).subscribe(
      (res) => { this.tokenInformationServe = res.json(); return res.json(); },
      (err) => { this.celebrate('We could not get your Token Info,Please check your internet connection ', 'Okay'); return []; }
    );
  }

  public celebrate(message, action = 'Okay') {
    this.snackBar.open(message, action, {
      duration: 4000,
      verticalPosition: 'top',
      horizontalPosition: 'right'
    });
  }

  public getDateTime() {
    var today = new Date();
    let month, day, time, hr, min, sec;
    hr = today.getUTCHours() < 10 ? "0" + today.getUTCHours() : today.getUTCHours();
    min = today.getUTCMinutes() < 10 ? "0" + today.getUTCMinutes() : today.getUTCMinutes();
    sec = today.getUTCSeconds() < 10 ? "0" + today.getUTCSeconds() : today.getUTCSeconds();
    time = hr + ':' + min + ':' + sec;
    month = (today.getMonth() + 1) < 10 ? "0" + (today.getMonth() + 1) : (today.getMonth() + 1);
    day = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
    day = month.toString().length == 3 ? (today.getMonth() + 1) : day.toString();
    var date = today.getFullYear() + '-' + month + '-' + day + 'T' + time + '.000Z';
    return date;
  }

  public getTheDate() {
    var today = new Date();
    let month, day;
    month = (today.getMonth() + 1) < 10 ? "0" + (today.getMonth() + 1) : (today.getMonth() + 1);
    day = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
    day = month.toString().length == 3 ? (today.getMonth() + 1) : day.toString();
    var date = today.getFullYear() + '-' + month + '-' + day //+ 'T' + time + '.000Z';
    return date;
  }

  public getTheTime() {
    var today = new Date();
    let time, hr, min, sec;
    hr = today.getUTCHours() < 10 ? "0" + today.getUTCHours() : today.getUTCHours();
    min = today.getUTCMinutes() < 10 ? "0" + today.getUTCMinutes() : today.getUTCMinutes();
    sec = today.getUTCSeconds() < 10 ? "0" + today.getUTCSeconds() : today.getUTCSeconds();
    time = 'T' + hr + ':' + min + ':' + sec + '.000Z';
    return time;
  }

  public getTheTime2() {
    var today = new Date();
    let time, hr, min, sec;
    hr = today.getUTCHours() < 10 ? "0" + today.getUTCHours() : today.getUTCHours();
    min = today.getUTCMinutes() < 10 ? "0" + today.getUTCMinutes() : today.getUTCMinutes();
    sec = today.getUTCSeconds() < 10 ? "0" + today.getUTCSeconds() : today.getUTCSeconds();
    time = hr + ':' + min + ':' + sec + '.000Z';
    return time;
  }

  public getTheTime3() {
    var today = new Date();
    let time, hr, min, sec;
    let ampm = '';
    hr = today.getUTCHours() < 10 ? "0" + today.getUTCHours() : today.getUTCHours();
    ampm = today.getUTCHours() < 12 ? 'am' : 'pm'
    hr = today.getUTCHours() < 13 ? hr : "0" + (parseInt(hr) - 12);
    min = today.getUTCMinutes() < 10 ? "0" + today.getUTCMinutes() : today.getUTCMinutes();
    sec = today.getUTCSeconds() < 10 ? "0" + today.getUTCSeconds() : today.getUTCSeconds();
    time = hr + ':' + min + ' ' + ampm;
    return time;
  }

  // its not working
  public selectAllToggle(allSelected, selectedList, fullList, keyIn?: string) {
    if (allSelected == true) {
      selectedList = [];
      allSelected = false;
    }
    else {
      if (keyIn !== undefined) {
        let newList = [];
        fullList.forEach(element => {
          newList.push(element[`${keyIn}`])
        });
        selectedList = newList;
      }
      else {
        selectedList = [...fullList];
        allSelected = true;
      }
    }


  }

  // neither is this
  public confirmAllSelected(allSelected, selectedList, fullList) {
    allSelected = selectedList.length == fullList.length ? true : false;
  }

  public currencyExchange(arrayIn, currency_id) {
    arrayIn.forEach(element => {
      if (element.Base_Currency_Identifier == currency_id) {
        element.AmountToShow = element.Base_Amount / element.Base_Currency_Exchange_Rate;
        element.AmountToShowCopy = element.Base_Amount / element.Base_Currency_Exchange_Rate;
      }
      else if (element.Foreign_Currency_Identifier_1 == currency_id) {
        element.AmountToShow = element.Base_Amount / element.Foreign_Currency_Identifier_1_Exchange_Rate;
        element.AmountToShowCopy = element.Base_Amount / element.Foreign_Currency_Identifier_1_Exchange_Rate;
      }
      else if (element.Foreign_Currency_Identifier_2 == currency_id) {
        element.AmountToShow = element.Base_Amount / element.Foreign_Currency_Identifier_2_Exchange_Rate;
        element.AmountToShowCopy = element.Base_Amount / element.Foreign_Currency_Identifier_2_Exchange_Rate;
      }
      else if (element.Foreign_Currency_Identifier_3 == currency_id) {
        element.AmountToShow = element.Base_Amount / element.Foreign_Currency_Identifier_3_Exchange_Rate;
        element.AmountToShowCopy = element.Base_Amount / element.Foreign_Currency_Identifier_3_Exchange_Rate;
      }
      else {
        element.AmountToShow = 0.00;
        element.AmountToShowCopy = 0.00;
      }
    });

    if (arrayIn[0] !== undefined) {
      if (arrayIn[0].BalanceToShow !== undefined) {
        arrayIn.forEach(element => {
          if (element.Base_Currency_Identifier == currency_id) {
            element.BalanceToShow = element.Base_Amount2 / element.Base_Currency_Exchange_Rate;
          }
          else if (element.Foreign_Currency_Identifier_1 == currency_id) {
            element.BalanceToShow = element.Base_Amount2 / element.Foreign_Currency_Identifier_1_Exchange_Rate;
          }
          else if (element.Foreign_Currency_Identifier_2 == currency_id) {
            element.BalanceToShow = element.Base_Amount2 / element.Foreign_Currency_Identifier_2_Exchange_Rate;
          }
          else if (element.Foreign_Currency_Identifier_3 == currency_id) {
            element.BalanceToShow = element.Base_Amount2 / element.Foreign_Currency_Identifier_3_Exchange_Rate;
          }
          else {
            element.BalanceToShow = 0.00;
          }
        });
      }
      if (arrayIn[0].Original_Amount !== undefined) {
        arrayIn.forEach(element => {
          if (element.Base_Currency_Identifier == currency_id) {
            element.Original_Amount2 = element.Original_Base_Amount ? element.Original_Base_Amount / element.Base_Currency_Exchange_Rate : element.Original_Amount / element.Base_Currency_Exchange_Rate;
          }
          else if (element.Foreign_Currency_Identifier_1 == currency_id) {
            element.Original_Amount2 = element.Original_Base_Amount ? element.Original_Base_Amount / element.Foreign_Currency_Identifier_1_Exchange_Rate : element.Original_Amount / element.Foreign_Currency_Identifier_1_Exchange_Rate;
          }
          else if (element.Foreign_Currency_Identifier_2 == currency_id) {
            element.Original_Amount2 = element.Original_Base_Amount ? element.Original_Base_Amount / element.Foreign_Currency_Identifier_2_Exchange_Rate : element.Original_Amount / element.Foreign_Currency_Identifier_2_Exchange_Rate;
          }
          else if (element.Foreign_Currency_Identifier_3 == currency_id) {
            element.Original_Amount2 = element.Original_Base_Amount ? element.Original_Base_Amount / element.Foreign_Currency_Identifier_3_Exchange_Rate : element.Original_Amount / element.Foreign_Currency_Identifier_3_Exchange_Rate;
          }
          else {
            element.Original_Amount2 = 0.00;
          }
        });
      }
      if (arrayIn[0].Amount !== undefined) {
        arrayIn.forEach(element => {
          if (element.Base_Currency_Identifier == currency_id) {
            element.Amount2 = element.Amount_Base_Amount ? element.Amount_Base_Amount / element.Base_Currency_Exchange_Rate : element.Amount / element.Base_Currency_Exchange_Rate;
          }
          else if (element.Foreign_Currency_Identifier_1 == currency_id) {
            element.Amount2 = element.Amount_Base_Amount ? element.Amount_Base_Amount / element.Foreign_Currency_Identifier_1_Exchange_Rate : element.Amount / element.Foreign_Currency_Identifier_1_Exchange_Rate;
          }
          else if (element.Foreign_Currency_Identifier_2 == currency_id) {
            element.Amount2 = element.Amount_Base_Amount ? element.Amount_Base_Amount / element.Foreign_Currency_Identifier_2_Exchange_Rate : element.Amount / element.Foreign_Currency_Identifier_2_Exchange_Rate;
          }
          else if (element.Foreign_Currency_Identifier_3 == currency_id) {
            element.Amount2 = element.Amount_Base_Amount ? element.Amount_Base_Amount / element.Foreign_Currency_Identifier_3_Exchange_Rate : element.Amount / element.Foreign_Currency_Identifier_3_Exchange_Rate;
          }
          else {
            element.Amount2 = 0.00;
          }
        });
      }
    }

    return arrayIn;
  }

  public currencyChange(arrayIn, currency_id) {
    arrayIn.forEach(element => {
      if (element.Base_Currency_Identifier == currency_id) {
        element.AmountToShow = element.Total_Base_Currency_Amt;
      }
      else if (element.Foreign_Currency_Identifier_1 == currency_id) {
        element.AmountToShow = element.Total_Foreign_Currency_Identifier_1_Amt;
      }
      else if (element.Foreign_Currency_Identifier_2 == currency_id) {
        element.AmountToShow = element.Total_Foreign_Currency_Identifier_2_Amt;
      }
      else if (element.Foreign_Currency_Identifier_3 == currency_id) {
        element.AmountToShow = element.Total_Foreign_Currency_Identifier_1_Amt;
      }
      else {
        element.AmountToShow = 0.00;
      }
    });

    return arrayIn;
  }

  public currencyChangeBalance(arrayIn, currency_id) {
    arrayIn.forEach(element => {
      if (element.Base_Currency_Identifier == currency_id) {
        element.AmountToShow = element.Balance_Base_Currency_Amt;
      }
      else if (element.Foreign_Currency_Identifier_1 == currency_id) {
        element.AmountToShow = element.Balance_Currency_1_Amt;
      }
      else if (element.Foreign_Currency_Identifier_2 == currency_id) {
        element.AmountToShow = element.Balance_Currency_2_Amt;
      }
      else if (element.Foreign_Currency_Identifier_3 == currency_id) {
        element.AmountToShow = element.Balance_Currency_3_Amt;
      }
      else {
        element.AmountToShow = 0.00;
      }
    });

    return arrayIn;
  }

  public classfilterAlgo(arrayItem) {
    let list = [];
    let ishere;
    arrayItem.forEach(element => {
      if (list.length !== 0) {
        ishere = true;
        list.forEach(element2 => {
          if (element2.Classroom_Identifier == element.Classroom_Identifier) { ishere = false; }
        });
        if (ishere) {
          // if (element.Course_Identifier == null) {
          list.push(element)
          // }
        }
      }
      else {
        // if (element.Course_Identifier == null) {
        list.push(element)
        // }
      }
    });
    list = _.sortBy(list, 'Classroom_Name');
    return list;
  }

  processDynamicChart(mainData, keyName, keyWeight?) {
    let formattedDataNameAndAmount = [];
    let billItemNamesRaw = [];
    let uniqueBillAmounts = [];

    let returnedObject = {
      "Labels": [],
      "Data": []
    }

    if (keyWeight) {
      mainData.map(grade => {
        formattedDataNameAndAmount.push({ "CategoryName": grade[`${keyName}`], "CategoryWeight": grade[`${keyWeight}`] });
      });
    } else {
      mainData.map(grade => {
        formattedDataNameAndAmount.push({ "CategoryName": grade[`${keyName}`], "CategoryWeight": 1 });
      });
    }
    // now lets prepare names the unique ones
    formattedDataNameAndAmount.map(oneDateAndName => {
      billItemNamesRaw.push(oneDateAndName.CategoryName);
    });
    // get all unique line item names
    let billItemNamesUnique = billItemNamesRaw.filter((x, i, a) => a.indexOf(x) == i);
    // the bills item names unique
    billItemNamesUnique.map(oneBill => {
      uniqueBillAmounts.push({ "catName": oneBill, "weightCollection": [] });
    });
    // now lets prepare amounts unique ones
    uniqueBillAmounts.map(oneUniqueValue => {
      formattedDataNameAndAmount.map(oneDataAmount => {
        if (oneUniqueValue.catName === oneDataAmount.CategoryName) {
          oneUniqueValue.weightCollection.push(oneDataAmount.CategoryWeight)
        }
      });
    });
    // bill Total Values
    let billTotalAmounts = [];
    // unique values
    uniqueBillAmounts.map(oneBill => {
      let tempTotal;
      tempTotal = oneBill.weightCollection.length !== 0 ? oneBill.weightCollection.reduce((accumulator, currentValue) => accumulator + currentValue) : 0;
      billTotalAmounts.push(tempTotal);
    });
    // the bills labels
    billItemNamesUnique.map((oneBillLabel, index) => {
      returnedObject.Labels.push(`${oneBillLabel} - ${billTotalAmounts[index]}`);
    })
    // bill amounts
    billTotalAmounts.map(oneAmount => {
      returnedObject.Data.push(oneAmount.toFixed(2));
    })

    return returnedObject;
  }

  categoryList = [];
  getCategories() {
    this.categoryList = [];
    this.showSpinner('Loading School Grade Categories');
    const url = this.apiUrl + '/school/grade_category?' + '&school_id=' + this.school_id;
    this.http.get(url, this.returnRequestOptions()).subscribe(
      res => {
        this.closeSpinner();
        const cats = res.json();
        if (cats.message === "No data found.") {
          this.celebrate("No Categories Found", "Okay");
        } else {
          this.categoryList = _.sortBy(cats, 'Name')
        }
      },
      err => {
        this.closeSpinner();
        const error = err.json();
        error.message == 'No data found' ? this.celebrate("No Categories Found", "Okay") : this.celebrate("No Categories Found", "Okay");
      }
    );
  }

  getCategoriesForClass(gl, uiPermissionName?: string) {
    this.categoryList = [];
    this.showSpinner('Loading Grade Level Categories');
    const url = '/school/grade_category?' + '&school_id=' + this.school_id + '&grade_level=' + gl + this.getActivityForUrl(undefined, 'Fetch School Grade Category', undefined, uiPermissionName);
    this.getHttp(url).subscribe(
      res => {
        this.closeSpinner();
        const cats = res.json();
        if (cats.message === "No data found.") {
          this.celebrate("No Categories Found", "Okay");
        } else {
          this.categoryList = _.sortBy(cats, 'Name')
        }
      },
      err => {
        this.closeSpinner();
        this.celebrate(err._body.toString());
      }
    );
  }

  /**
   *
   * @param url eg. /classroom
   * @returns observable to subscribe to
   */
  getHttp(url) {
    return this.http.get(this.apiUrl + url, this.returnRequestOptions())
  }

  async httpGetAsync(url) {
    let response;
    try {
      response = await this.http.get(this.apiUrl + url, this.returnRequestOptions()).toPromise();
    } catch (error) {
      response = error
    }
    return response;
  }

  async httpPutAsync(url, body) {
    let response;
    try {
      response = await this.http.put(this.apiUrl + url, body, this.returnRequestOptions()).toPromise();
    } catch (error) {
      response = error
    }
    return response;
  }

  async httpPatchAsync(url, body) {
    let response;
    try {
      response = await this.http.patch(this.apiUrl + url, body, this.returnRequestOptions()).toPromise();
    } catch (error) {
      response = error
    }
    return response;
  }

  async httpPostAsync(url, body) {
    let response;
    try {
      response = await this.http.post(this.apiUrl + url, body, this.returnRequestOptions()).toPromise();
    } catch (error) {
      response = error
    }
    return response;
  }

  async httpDeleteAsync(url, body) {
    let response;
    let reqOpts = this.returnRequestOptions();
    reqOpts.body = body;
    try {
      response = await this.http.delete(this.apiUrl + url, reqOpts).toPromise();
    } catch (error) {
      response = error
    }
    return response;
  }

  public returnCardRequestOptions() {
    const requestOptions = new RequestOptions();
    requestOptions.headers = this.returnCardHeaders();
    return requestOptions;
  }

  public returnCardHeaders() {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    // headers.append('Access-Control-Allow-Headers', '*');
    // headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Authorization', 'Basic ' + btoa(environment.cardIntegrationUsername + ':' + environment.cardIntegrationPassword));
    return headers;
  }

  async httpCreateCardSessionAsync(currency?, amount?) {
    let body = {
      "apiOperation": "INITIATE_CHECKOUT",
      "interaction": {
        "operation": "PURCHASE"
      },
      "order": {
        "id": "info-" + this.getDateTime() + "-dev-web",
        "amount": amount ? amount : "1.00",
        "currency": currency ? currency : "GHS"
      }
    };

    let response;
    try {
      response = await this.http.post('https://eu-gateway.mastercard.com/api/rest/version/72/merchant/' + environment.cardIntegrationMerchantID + '/session', body, this.returnCardRequestOptions()).toPromise();
    } catch (error) {
      response = error
    }
    return response;
  }

  async httpCardSessionUpdateAsync(orderID, transactionID, body) {
    let response;
    try {
      response = await this.http.put('https://eu-gateway.mastercard.com/api/rest/version/72/merchant/' + environment.cardIntegrationMerchantID + '/order/' + orderID + "/transaction/" + transactionID, body, this.returnCardRequestOptions()).toPromise();
    } catch (error) {
      response = error
    }
    return response;
  }

  /**
   *
   * @param url eg /classroom
   * @param body body to send
   * @param fileUpload if it is a file upload
   * @returns observable to subscribe to
   */
  postHttp(url, body, fileUpload?) {
    return this.http.post(this.apiUrl + url, body, fileUpload ? this.returnRequestOptions2() : this.returnRequestOptions())

  }

  /**
   *
   * @param url eg. /classroom
   * @param body
   * @returns obeservable to subscribe to
   */
  putHttp(url, body) {
    return this.http.put(this.apiUrl + url, body, this.returnRequestOptions())

  }

  /**
   *
   * @param url eg. /classroom
   * @param body
   * @returns obeservable to subscribe to
   */
  deleteHttp(url, body) {
    let requestOptions = this.returnRequestOptions()
    requestOptions.body = body
    return this.http.delete(this.apiUrl + url, requestOptions)
  }


  /**
  *
  * @param url eg. /classroom
  * @param body
  * @returns obeservable to subscribe to
  */
  deleteOptional(url) {
    let requestOptions = this.returnRequestOptions()
    return this.http.delete(this.apiUrl + url, requestOptions)
  }


  /**
   *
   * @param studentsList array of students
   * @param id Classroom identifier
   * @returns array of students in class
   */
  getStudentsInClass(studentsList, id: number) {
    return studentsList.filter(({ Classroom_Identifier }: { Classroom_Identifier: number }) => Classroom_Identifier === id)
  }


  /**
   *
   * @param Terms list of school terms
   * @returns the term id of the first match or '' if no match
   */
  getCurrentTermId(Terms: any[]) {
    const term = Terms.find(term => term.Current_Term_Indicator == 1)
    if (!term) return ''
    return String(term.School_Term_Identifier)
  }

  /**
   *
   * @param start begin date to compare :Date
   * @param end end date to compare
   * @returns true if end date is after or equal to start date
   */
  startDateBeforeEndDate(start: Date, end: Date) {
    return end.getTime() >= start.getTime()
  }

  /**
   *  ignore both if page title is set to in the module ~ ui standart eg. Report Management ~ Class Development Assessment
   * @param module Client_Application_Module eg. Financial Manangement
   * @param feature Client_Application_Feature eg. Edit Advance Payment
   * @returns app_module=Administration&app_feature=School Notification Report&client_app=SIMS&client_os=Web.
   */
  getActivityForUrl(module?: string, feature?: string, properUIname?: string, uiPermissionName?: string): string {
    let details: string[] = [];
    let clientResourceID = null;
    if (this.pageTitleService.title.value !== null) {
      details = this.pageTitleService.title.value.split(' ~ ')
    }
    if (uiPermissionName || details.length) {
      let name = uiPermissionName ? uiPermissionName : details[1];
      clientResourceID = this.resolveClientResourceID(name);
    }
    if (!module && !details.length || (this.pageTitleService.title.value == 'Home')) {
      details = ['Home', 'Homepage'];
    }
    return `&app_module=${module || details[0]}&app_feature=${feature || details[1]}&app_ui=${properUIname ? properUIname : details[1]}&app_feature_id=${clientResourceID}&client_app=SIMS&client_os=Web&user_id=${this.user_id}`;
  }

  public resolveClientResourceID(uiName) {
    let id = null;
    let permissions = this.roles ? JSON.parse(this.roles) : [];
    permissions.forEach(element => {
      if (element.Client_Application_Resource_Name == uiName && element.Client_Application_Name=="SIMS") {
        // 
        // id = 'UI ID';
        id = element.Client_Application_Resource_Identifier;
      }
    });
    return id;
  }

  public returnPaymentModesForUI(ui:string, spsps?:any[]){
    let result = {
      offlinePaymentModes: [],
      onlinePaymentModes: []
    }

    if (!spsps) {
      spsps = this.schoolServiceProvidersCache ? JSON.parse(this.schoolServiceProvidersCache) : [];
    }

    let tempOnlinePaymentModes:any[] = [];
    let tempOfflinePaymentModes:any[] = [];

    let carID = this.resolveClientResourceID(ui);
    
    for(let spsp of spsps){
      if (spsp.School_Payment_Service_Provider_Client_Application_Resource) {
        let uiIncluded = spsp.School_Payment_Service_Provider_Client_Application_Resource.find(clientRecord => clientRecord.Client_Application_Resource_Identifier ==  carID);
        if (uiIncluded && uiIncluded.Status == 'Active') {
          spsp.Payment_Service_Display_Name = spsp.Payment_Service_Display_Name ? spsp.Payment_Service_Display_Name : spsp.Payment_Service_Provider_Name;
          if (spsp.Provider_Method) {
            tempOnlinePaymentModes.push(spsp);
          } else {
            tempOfflinePaymentModes.push(spsp);
          }
        }
      }
    }

    if (!tempOfflinePaymentModes.length && this.backCompatActive) {
      tempOnlinePaymentModes = spsps.filter(prov => prov.Provider_Method);
      for(let spsp of tempOnlinePaymentModes) { spsp.Payment_Service_Display_Name = spsp.Payment_Service_Display_Name ? spsp.Payment_Service_Display_Name : spsp.Payment_Service_Provider_Name; }
    }


    result.onlinePaymentModes = _.sortBy(tempOnlinePaymentModes, 'Payment_Service_Display_Name');

    let agreement = this.checkForCurrentAgreement();
    if (agreement.length && agreement[0].Offline_Payment_Mode_Included == "Yes") {
      if (this.apiUrl == this.httpsDevApiUrl || !this.backCompatActive) {
        result.offlinePaymentModes = _.sortBy(tempOfflinePaymentModes, 'Payment_Service_Display_Name');        
      } else {
        result.offlinePaymentModes = _.sortBy(this.offlinePaymentModesList, 'Payment_Service_Display_Name');        
      }
    }

    return result;
  }

  async returnPaymentModeDisplayNames(incomingArray:any[]){
    let spsps = this.schoolServiceProvidersCache ? JSON.parse(this.schoolServiceProvidersCache) : [];
    for(let record of incomingArray){
      let pModeFound = spsps.find(sp => sp.Payment_Service_Provider_Name == record.Payment_Mode);
      // let pModeFound = this.allSPSPs.find(sp => sp.School_Payment_Service_Provider_Identifier == record.School_Payment_Service_Provider_Identifier);
      record.Payment_Service_Display_Name = pModeFound ? pModeFound.Payment_Service_Display_Name ? pModeFound.Payment_Service_Display_Name : pModeFound.Payment_Service_Provider_Name : record.Payment_Mode;
    }
  }

  singlePermissionCheck(permission: string) {
    let hasThisPermission: boolean = false;
    let permissions = this.roles ? JSON.parse(this.roles) : [];
    permissions.forEach(element => {
      if (element.Client_Application_Resource_Name == permission && element.Permission_Value == 1) {
        hasThisPermission = true;
      }
    });

    return hasThisPermission;
  }

  formName(cat, namesToOrder) {
    if (cat == "First Name - Middle Name - Last Name") {
      namesToOrder.forEach(element => {
        element.Student_Name = element.Middle_Name !== null ? element.Frist_Name + " " + element.Middle_Name + " " + element.Last_Name : element.Frist_Name + " " + element.Last_Name;
      });
    }
    else if (cat == "Last Name - Middle Name - First Name") {
      namesToOrder.forEach(element => {
        element.Student_Name = element.Middle_Name !== null ? element.Last_Name + " " + element.Middle_Name + " " + element.Frist_Name : element.Last_Name + " " + element.Frist_Name;
      });
    }
    else if (cat == "First Name - Last Name - Middle Name") {
      namesToOrder.forEach(element => {
        element.Student_Name = element.Middle_Name !== null ? element.Frist_Name + " " + element.Last_Name + " " + element.Middle_Name : element.Frist_Name + " " + element.Last_Name;
      });
    }
    else if (cat == "Last Name - First Name - Middle Name") {
      namesToOrder.forEach(element => {
        element.Student_Name = element.Middle_Name !== null ? element.Last_Name + " " + element.Frist_Name + " " + element.Middle_Name : element.Last_Name + " " + element.Frist_Name;
      });
    }
  }

  sortName(cat, namesToOrder) {
    if (cat == "First Name (Ascending)") {
      namesToOrder = _.orderBy(namesToOrder, [student => student.Frist_Name.toLowerCase()], ['asc']);
    }
    else if (cat == "First Name (Descending)") {
      namesToOrder = _.orderBy(namesToOrder, [student => student.Frist_Name.toLowerCase()], ['desc']);
    }
    else if (cat == "Last Name (Ascending)") {
      namesToOrder = _.orderBy(namesToOrder, [student => student.Last_Name.toLowerCase()], ['asc']);
    }
    else if (cat == "Last Name (Descending)") {
      namesToOrder = _.orderBy(namesToOrder, [student => student.Last_Name.toLowerCase()], ['desc']);
    }
  }

  getDistinctElement(list) {
    let filtered = [];
    list.forEach(element => {
      if (filtered.length !== 0) {
        let valuePresent = false;
        filtered.forEach(f_element => {
          if (f_element == element) {
            valuePresent = true;
          }
        });

        if (!valuePresent) {
          filtered.push(element);
        }
      }
      else {
        filtered.push(element);
      }
    });
    return filtered;
  }

  getDistinct(arrayKey, list) {
    let filtered = [];
    list.forEach(element => {
      if (filtered.length !== 0) {
        let valuePresent = false;
        filtered.forEach(f_element => {
          if (f_element[arrayKey] == element[arrayKey]) {
            valuePresent = true;
          }
        });

        if (!valuePresent) {
          filtered.push(element);
        }
      }
      else {
        filtered.push(element);
      }
    });
    return filtered;
  }

  getDistinct2(arrayKey1, arrayKey2, list) {
    let filtered = [];
    list.forEach(element => {
      if (filtered.length !== 0) {
        let valuePresent = false;
        filtered.forEach(f_element => {
          if (f_element[arrayKey1] == element[arrayKey1] && f_element[arrayKey2] == element[arrayKey2]) {
            valuePresent = true;
          }
        });

        if (!valuePresent) {
          filtered.push(element);
        }
      }
      else {
        filtered.push(element);
      }
    });
    return filtered;
  }

  setColor() {
    setTimeout(() => {
      if (this.school_color !== '#c5c5c5') {
        document.body.style.setProperty('--schcol', this.school_color);
        document.body.style.setProperty('--schcol2', this.school_color2);
      } else {
        setTimeout(() => {
          if (this.school_color !== '#c5c5c5') {
            document.body.style.setProperty('--schcol', this.school_color);
            document.body.style.setProperty('--schcol2', this.school_color2);
          }
          else {
            setTimeout(() => {
              if (this.school_color !== '#c5c5c5') {
                document.body.style.setProperty('--schcol', this.school_color);
                document.body.style.setProperty('--schcol2', this.school_color2);
              }
              else {
                setTimeout(() => {
                  document.body.style.setProperty('--schcol', this.school_color);
                  document.body.style.setProperty('--schcol2', this.school_color2);
                }, 2000);
              }
            }, 2000);
          }
        }, 2000);
      }
    }, 2000);
  }

  buttonStyle(condition): Object {
    if (condition) {
      return {
        background: 'var(--schcol, #c5c5c5)',
        color: '#fff'
      }
    }
    else {
      return {
        background: '#fff',
        color: 'var(--schcol, #c5c5c5)'
      }
    }
  }

  doubleStyle(condition, comparison): Object {
    if (condition == comparison) {
      return {
        background: 'var(--schcol, #c5c5c5)',
        color: '#fff'
      }
    }
    else {
      return {
        background: '#fff',
        color: '#414658'
      }
    }
  }

  doubleStyle2(condition, comparison): Object {
    // if (condition == comparison){
    return {
      background: 'var(--schcol2, #c5c5c5)',
      color: 'var(--schcol, #c5c5c5)'
    }
    // }
    // else{
    //   return {
    //     background: '#fff',
    //     color: '#414658'
    //   }
    // }
  }

  /**
   *
   * @param date an optional date, if nothing is passed today's date and time will be used
   * @returns date formatted eg. 2021-20-12
   */
  getDateFormatted(date?) {
    if (!date)
      return new Date().toJSON().substring(0, 10)
    return new Date(date).toJSON().substring(0, 10);
  }

  getStudentFullName(student) {
    student.Full_Name = student.Middle_Name !== null ? student.Frist_Name + " " + student.Middle_Name + " " + student.Last_Name : student.Frist_Name + " " + student.Last_Name;
    return student.Full_Name;
  }

  getStudentFullName2(student) {
    student.Full_Name = student.Student_Middle_Name !== null && student.Student_Middle_Name !== " " ? student.Student_First_Name + " " + student.Student_Middle_Name + " " + student.Student_Last_Name : student.Student_First_Name + " " + student.Student_Last_Name;
    return student.Full_Name;
  }

  branchFilter(branchID, classroomArray) {
    let forThisBranch = [];
    classroomArray.forEach(element => {
      if (element.Branch_Identifier == branchID) {
        forThisBranch.push(element);
      }
    });
    return forThisBranch;
  }

  getHttpUnsubcribable(url) {
    return this.http.get(this.apiUrl + url, this.returnRequestOptions()).pipe(takeUntil(this.ngUnsubscribe));
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  dialogRef: MatDialogRef<LoadingModalComponent>;
  isOpenCount: number = 0
  public showSpinner(messageIn?: string) {
    this.isOpenCount = this.isOpenCount + 1

    if (this.dialogRef != null || this.dialogRef != undefined) {
      return
    }
    if (messageIn !== undefined) {
      this.dialogRef = this.dialog.open(LoadingModalComponent, {
        width: "400px",
        disableClose: true,
        data: {
          type: "spinner",
          cancellable: false,
          message: messageIn,
          cancel_action: () => {
            this.isOpenCount = 0
            this.dialogRef.close();
            this.dialogRef = undefined;
          }
        }
      })
    } else {
      this.dialogRef = this.dialog.open(LoadingModalComponent, {
        width: "400px",
        disableClose: true,
        data: {
          type: "spinner",
          cancellable: false,
          cancel_action: () => {
            this.isOpenCount = 0
            this.dialogRef.close();
            this.dialogRef = undefined;
          }
        }
      })
    }
  }

  public closeSpinner() {
    if (this.dialogRef !== undefined) {
      this.isOpenCount = this.isOpenCount - 1
      if (this.isOpenCount == 0) {
        this.dialogRef.close();
        this.dialogRef = undefined
      }
    }
  }


  /**
   *
   * @param title this is the alert title of the page of type String
   * @param messageIn this is the message or alert message of the modal of type String
   * @param confirmAction this Confirm action function that takes the form of a eg..()=>{this.functionName()} or ()=>{Function}
   * @param cancelAction this Close action function that takes the form of a eg..()=>{this.functionName()} or ()=>{Function}
   * @param cancel_text this is the cancel button innertext of type String
   * @param confirm_text this is the confirm button innertext of type String
   * @returns
   */

  alertRef: MatDialogRef<LoadingModalComponent>;
  public async showAlert(title: string, messageIn: any, confirmAction?, cancelAction?, confirm_text?: string, cancel_text?: string, cancel_text_normal?: boolean,type?:string) {

    if (this.alertRef != null || this.alertRef != undefined) {
      // this.alertRef.componentInstance.data.message = this.alertRef.componentInstance.data.message+'<br><br>'+messageIn
      const mms = this.alertRef.componentInstance?this.alertRef.componentInstance.data.message+ '<br><br>':''
      if(mms){
        this.alertRef.componentInstance.data.message = mms + messageIn
      }else{
        this.alertRef.close()
        this.alertRef = undefined

      }

      

      return
    }
    this.alertRef = this.alertdialog.open(LoadingModalComponent, {
      width: "430px",
      disableClose: true,
      data: {
        type: !type?"alert":type,
        title: title,
        message: messageIn,
        confirm: confirm_text,
        close: cancel_text,
        cancel_action: () => { cancelAction(); this.alertRef.close(); this.alertRef = undefined },
        confirm_action: () => { confirmAction(); this.alertRef.close(); this.alertRef = undefined },
        cancel_text_normal: cancel_text_normal,
        closeModal: () => {
          this.alertRef.close();
          this.alertRef = undefined;
        }
        // assInnerHTML: asInnerHTML
      }
    })
  }

  public showServicePackageAlert(){
    if (!sessionStorage.getItem('ExpiredSchoolAgreement')) {
      sessionStorage.setItem('ExpiredSchoolAgreement', 'true');
      setTimeout(() => {
        this.alertRef = this.alertdialog.open(LoadingModalComponent, {
          width: "68%",
          disableClose: true,
          data: {
            type: "prepaid",
            title: '',
            message: '',
            confirm: "Renew Agreement",
            close: "Cancel",
            cancel_action: () => {this.alertRef.close(); this.alertRef = undefined },
            confirm_action: () => { this.router.navigate(['/school-subscriptions/subscriptions'],{queryParams:{"renewal":true}}); this.alertRef.close(); this.alertRef = undefined },
            cancel_text_normal: '',
            // assInnerHTML: asInnerHTML
          }
        })
      }, 2000);    
    }
  }


  /**
   *
   * @param title this is the alert title of the page of type String
   * @param Components this is the sting form of html elements eg.."<p style='color:red;'>garden</p>"
   * @param confirmAction this Confirm action function that takes the form of a eg..()=>{this.functionName()} or ()=>{Function}
   * @param cancelAction this Close action function that takes the form of a eg..()=>{this.functionName()} or ()=>{Function}
   * @param cancel_text this is the cancel button innertext of type String
   * @param confirm_text this is the confirm button innertext of type String
   * @returns
   */

  info: MatDialogRef<LoadingModalComponent>;
  public showinfo(title?: string, components?: string, confirmAction?, cancelAction?, confirm_text?: string, cancel_text?: string) {

    if (this.info != null || this.info != undefined) {
      return
    }
    this.info = this.alertdialog.open(LoadingModalComponent, {
      width: "600px",
      disableClose: true,
      data: {
        type: "info",
        title: title || 'INFORMATION',
        message: components || 'Hello World',
        confirm: confirm_text,
        close: cancel_text,
        cancel_action: () => { cancelAction(); this.info.close(); this.info = undefined },
        confirm_action: () => { confirmAction(); this.info.close(); this.info = undefined }
      }
    })
  }

  turndate(date: Date) {
    date = new Date(date)
    let day = date.getDate().toString().length < 2 ? "0" + date.getDate() : date.getDate()
    let month = (date.getMonth() + 1).toString().length < 2 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)
    let year = date.getFullYear()
    let fulldate = `${year}-${month}-${day}`
    return fulldate
  }

  public handleErrorMessage(rez) {
    try { let msg = rez.json(); let msgStr = msg.message ? msg.message : msg.msg; this.celebrate(msgStr); } catch (error) { this.celebrate(rez._body.toString()); }
  }

  public nationalities = [
    'Ghanaian',
    'Afghan',
    'Albanian',
    'Algerian',
    'American',
    'Andorran',
    'Angolan',
    'Antiguans',
    'Argentinean',
    'Armenian',
    'Australian',
    'Austrian',
    'Azerbaijani',
    'Bahamian',
    'Bahraini',
    'Bangladeshi',
    'Barbadian',
    'Barbudans',
    'Batswana',
    'Belarusian',
    'Belgian',
    'Belizean',
    'Beninese',
    'Bhutanese',
    'Bolivian',
    'Bosnian',
    'Brazilian',
    'British',
    'Bruneian',
    'Bulgarian',
    'Burkinabe',
    'Burmese',
    'Burundian',
    'Cambodian',
    'Cameroonian',
    'Canadian',
    'Cape Verdean',
    'Central African',
    'Chadian',
    'Chilean',
    'Chinese',
    'Colombian',
    'Comoran',
    'Congolese',
    'Costa Rican',
    'Croatian',
    'Cuban',
    'Cypriot',
    'Czech',
    'Danish',
    'Djibouti',
    'Dominican',
    'Dutch',
    'East Timorese',
    'Ecuadorean',
    'Egyptian',
    'Emirian',
    'Equatorial Guinean',
    'Eritrean',
    'Estonian',
    'Ethiopian',
    'Fijian',
    'Filipino',
    'Finnish',
    'French',
    'Gabonese',
    'Gambian',
    'Georgian',
    'German',
    'Greek',
    'Grenadian',
    'Guatemalan',
    'Guinea-Bissauan',
    'Guinean',
    'Guyanese',
    'Haitian',
    'Herzegovinian',
    'Honduran',
    'Hungarian',
    'I-Kiribati',
    'Icelander',
    'Indian',
    'Indonesian',
    'Iranian',
    'Iraqi',
    'Irish',
    'Israeli',
    'Italian',
    'Ivorian',
    'Jamaican',
    'Japanese',
    'Jordanian',
    'Kazakhstani',
    'Kenyan',
    'Kittian and Nevisian',
    'Kuwaiti',
    'Kyrgyz',
    'Laotian',
    'Latvian',
    'Lebanese',
    'Liberian',
    'Libyan',
    'Liechtensteiner',
    'Lithuanian',
    'Luxembourger',
    'Macedonian',
    'Malagasy',
    'Malawian',
    'Malaysian',
    'Maldivan',
    'Malian',
    'Maltese',
    'Marshallese',
    'Mauritanian',
    'Mauritian',
    'Mexican',
    'Micronesian',
    'Moldovan',
    'Monacan',
    'Mongolian',
    'Moroccan',
    'Mosotho',
    'Motswana',
    'Mozambican',
    'Namibian',
    'Nauruan',
    'Nepalese',
    'New Zealander',
    'Nicaraguan',
    'Nigerian',
    'Nigerien',
    'North Korean',
    'Northern Irish',
    'Norwegian',
    'Omani',
    'Pakistani',
    'Palauan',
    'Panamanian',
    'Papua New Guinean',
    'Paraguayan',
    'Peruvian',
    'Polish',
    'Portuguese',
    'Qatari',
    'Romanian',
    'Russian',
    'Rwandan',
    'Saint Lucian',
    'Salvadoran',
    'Samoan',
    'San Marinese',
    'Sao Tomean',
    'Saudi',
    'Scottish',
    'Senegalese',
    'Serbian',
    'Seychellois',
    'Sierra Leonean',
    'Singaporean',
    'Slovakian',
    'Slovenian',
    'Solomon Islander',
    'Somali',
    'South African',
    'South Korean',
    'Spanish',
    'Sri Lankan',
    'Sudanese',
    'Surinamer',
    'Swazi',
    'Swedish',
    'Swiss',
    'Syrian',
    'Taiwanese',
    'Tajik',
    'Tanzanian',
    'Thai',
    'Togolese',
    'Tongan',
    'Trinidadian/Tobagonian',
    'Tunisian',
    'Turkish',
    'Tuvaluan',
    'Ugandan',
    'Ukrainian',
    'Uruguayan',
    'Uzbekistani',
    'Venezuelan',
    'Vietnamese',
    'Welsh',
    'Yemenite',
    'Zambian',
    'Zimbabwean'
  ];

  public countryCodes = [
    { country: 'Ghana', code: '+233' },
    { country: 'Afghanistan', code: '+93' },
    { country: 'Albania', code: '+355' },
    { country: 'Algeria', code: '+213' },
    { country: 'American Samoa', code: '+684' },
    { country: 'Andorra', code: '+376' },
    { country: 'Angola', code: '+244' },
    { country: 'Anguilla', code: '+1-264' },
    { country: 'Antarctica', code: '+672' },
    { country: 'Antigua and Barbuda', code: '+1-268' },
    { country: 'Argentina', code: '+54' },
    { country: 'Armenia', code: '+374' },
    { country: 'Aruba', code: '+297' },
    { country: 'Australia', code: '+61' },
    { country: 'Austria', code: '+43' },
    { country: 'Azerbaijan', code: '+994' },
    { country: 'Bahamas', code: '+1-242' },
    { country: 'Bahrain', code: '+973' },
    { country: 'Bangladesh', code: '+880' },
    { country: 'Barbados', code: '+1-246' },
    { country: 'Belarus', code: '+375' },
    { country: 'Belgium', code: '+32' },
    { country: 'Belize', code: '+501' },
    { country: 'Benin', code: '+229' },
    { country: 'Bermuda', code: '+1-441' },
    { country: 'Bhutan', code: '+975' },
    { country: 'Bolivia', code: '+591' },
    { country: 'Bosnia-Herzegovina', code: '+387' },
    { country: 'Botswana', code: '+267' },
    { country: 'Brazil', code: '+55' },
    { country: 'Brunei Darussalam', code: '+673' },
    { country: 'Bulgaria', code: '+359' },
    { country: 'Burkina Faso', code: '+226' },
    { country: 'Burundi', code: '+257' },
    { country: 'Cambodia', code: '+855' },
    { country: 'Cameroon', code: '+237' },
    { country: 'Canada', code: '+1' },
    { country: 'Cape Verde', code: '+238' },
    { country: 'Cayman Islands', code: '+1-345' },
    { country: 'Central African Republic', code: '+236' },
    { country: 'Chad', code: '+235' },
    { country: 'Chile', code: '+56' },
    { country: 'China', code: '+86' },
    { country: 'Christmas Island', code: '+61' },
    { country: 'Cocos Island', code: '+61' },
    { country: 'Columbia', code: '+57' },
    { country: 'Comoros', code: '+269' },
    { country: 'Cook Islands', code: '+682' },
    { country: 'Costa Rica', code: '+506' },
    { country: 'Croatia', code: '+385' },
    { country: 'Cuba', code: '+53' },
    { country: 'Curacao', code: '+599' },
    { country: 'Cyprus', code: '+357' },
    { country: 'Czech Republic', code: '+420' },
    { country: 'DRC - Congo', code: '+243' },
    { country: 'Denmark', code: '+45' },
    { country: 'Djibouti', code: '+253' },
    { country: 'Dominica', code: '+1767' },
    { country: 'Dominican Republic', code: '+1809' },
    { country: 'East Timor', code: '+670' },
    { country: 'Ecuador', code: '+593' },
    { country: 'Egypt', code: '+20' },
    { country: 'El Salvador', code: '+503' },
    { country: 'Equatorial Guinea', code: '+240' },
    { country: 'Eritrea', code: '+291' },
    { country: 'Estonia', code: '+372' },
    { country: 'Ethiopia', code: '+251' },
    { country: 'Falkland Islands', code: '+500' },
    { country: 'Faroe Islands', code: '+298' },
    { country: 'Fiji', code: '+679' },
    { country: 'Finland', code: '+358' },
    { country: 'France', code: '+33' },
    { country: 'French Polynesia', code: '+689' },
    { country: 'Gabon', code: '+241' },
    { country: 'Gambia', code: '+220' },
    { country: 'Georgia', code: '+995' },
    { country: 'Germany', code: '+49' },
    { country: 'Gibraltar', code: '+350' },
    { country: 'Greece', code: '+30' },
    { country: 'Greenland', code: '+299' },
    { country: 'Grenada', code: '+1473' },
    { country: 'Guadeloupe (French)', code: '+590' },
    { country: 'Guam (USA)', code: '+1-671' },
    { country: 'Guatemala', code: '+502' },
    { country: 'Guinea', code: '+224' },
    { country: 'Guinea Bissau', code: '+245' },
    { country: 'Guyana', code: '+592' },
    { country: 'Haiti', code: '+509' },
    { country: 'Honduras', code: '+504' },
    { country: 'Hong Kong', code: '+852' },
    { country: 'Hungary', code: '+36' },
    { country: 'Iceland', code: '+354' },
    { country: 'India', code: '+91' },
    { country: 'Indonesia', code: '+62' },
    { country: 'Iran', code: '+98' },
    { country: 'Iraq', code: '+964' },
    { country: 'Ireland', code: '+353' },
    { country: 'Israel', code: '+972' },
    { country: 'Italy', code: '+39' },
    { country: 'Ivory Coast', code: '+225' },
    { country: 'Jamaica', code: '+1-876' },
    { country: 'Japan', code: '+81' },
    { country: 'Jordan', code: '+962' },
    { country: 'Kazakhstan', code: '+7' },
    { country: 'Kenya', code: '+254' },
    { country: 'Kiribati', code: '+686' },
    { country: 'Korea-North', code: '+850' },
    { country: 'Korea-South', code: '+82' },
    { country: 'Kuwait', code: '+965' },
    { country: 'Kyrgyzstan', code: '+996' },
    { country: 'Laos', code: '+856' },
    { country: 'Latvia', code: '+371' },
    { country: 'Lebanon', code: '+961' },
    { country: 'Lesotho', code: '+266' },
    { country: 'Liberia', code: '+231' },
    { country: 'Libya', code: '+218' },
    { country: 'Liechtenstein', code: '+423' },
    { country: 'Lithuania', code: '+370' },
    { country: 'Luxembourg', code: '+352' },
    { country: 'Macau', code: '+853' },
    { country: 'Macedonia', code: '+389' },
    { country: 'Madagascar', code: '+261' },
    { country: 'Malawi', code: '+265' },
    { country: 'Malaysia', code: '+60' },
    { country: 'Maldives', code: '+960' },
    { country: 'Mali', code: '+223' },
    { country: 'Malta', code: '+356' },
    { country: 'Marshall Islands', code: '+692' },
    { country: 'Martinique (French)', code: '+596' },
    { country: 'Mauritania', code: '+222' },
    { country: 'Mauritius', code: '+230' },
    { country: 'Mayotte', code: '+269' },
    { country: 'Mexico', code: '+52' },
    { country: 'Micronesia', code: '+691' },
    { country: 'Moldova', code: '+373' },
    { country: 'Monaco', code: '+377' },
    { country: 'Mongolia', code: '+976' },
    { country: 'Montenegro', code: '+382' },
    { country: 'Montserrat', code: '+1-664' },
    { country: 'Morocco', code: '+212' },
    { country: 'Mozambique', code: '+258' },
    { country: 'Myanmar', code: '+95' },
    { country: 'Namibia', code: '+264' },
    { country: 'Nauru', code: '+674' },
    { country: 'Nepal', code: '+977' },
    { country: 'Netherlands', code: '+31' },
    { country: 'Netherlands Antilles', code: '+599' },
    { country: 'New Caledonia (French)', code: '+687' },
    { country: 'New Zealand', code: '+64' },
    { country: 'Nicaragua', code: '+505' },
    { country: 'Niger', code: '+227' },
    { country: 'Nigeria', code: '+234' },
    { country: 'Niue', code: '+683' },
    { country: 'Norfolk Island', code: '+672' },
    { country: 'Northern Mariana Islands', code: '+670' },
    { country: 'Norway', code: '+47' },
    { country: 'Oman', code: '+968' },
    { country: 'Pakistan', code: '+92' },
    { country: 'Palau', code: '+680' },
    { country: 'Panama', code: '+507' },
    { country: 'Papua New Guinea', code: '+675' },
    { country: 'Paraguay', code: '+595' },
    { country: 'Peru', code: '+51' },
    { country: 'Philippines', code: '+63' },
    { country: 'Poland', code: '+48' },
    { country: 'Polynesia (French)', code: '+689' },
    { country: 'Portugal', code: '+351' },
    { country: 'Puerto Rico', code: '+1-787' },
    { country: 'Qatar', code: '+974' },
    { country: 'Reunion (French)', code: '+262' },
    { country: 'Romania', code: '+40' },
    { country: 'Russia', code: '+7' },
    { country: 'Rwanda', code: '+250' },
    { country: 'Saint Helena', code: '+290' },
    { country: 'Saint Kitts & Nevis Anguilla', code: '+1-869' },
    { country: 'Saint Lucia', code: '+1-758' },
    { country: 'Saint Pierre and Miquelon', code: '+508' },
    { country: 'Saint Vincent & Grenadines', code: '+1-784' },
    { country: 'Samoa', code: '+684' },
    { country: 'San Marino', code: '+378' },
    { country: 'Sao Tome and Principe', code: '+239' },
    { country: 'Saudi Arabia', code: '+966' },
    { country: 'Senegal', code: '+221' },
    { country: 'Serbia', code: '+381' },
    { country: 'Seychelles', code: '+248' },
    { country: 'Sierra Leone', code: '+232' },
    { country: 'Singapore', code: '+65' },
    { country: 'Slovakia', code: '+421' },
    { country: 'Slovenia', code: '+386' },
    { country: 'Solomon Islands', code: '+677' },
    { country: 'Somalia', code: '+252' },
    { country: 'South Africa', code: '+27' },
    { country: 'South Sudan', code: '+211' },
    { country: 'Spain', code: '+34' },
    { country: 'Sri Lanka', code: '+94' },
    { country: 'Sudan', code: '+249' },
    { country: 'Suriname', code: '+597' },
    { country: 'Swaziland', code: '+268' },
    { country: 'Sweden', code: '+46' },
    { country: 'Switzerland', code: '+41' },
    { country: 'Syria', code: '+963' },
    { country: 'Taiwan', code: '+886' },
    { country: 'Tajikistan', code: '+992' },
    { country: 'Tanzania', code: '+255' },
    { country: 'Thailand', code: '+66' },
    { country: 'Togo', code: '+228' },
    { country: 'Tokelau', code: '+690' },
    { country: 'Tonga', code: '+676' },
    { country: 'Trinidad and Tobago', code: '+1-868' },
    { country: 'Tunisia', code: '+216' },
    { country: 'Turkey', code: '+90' },
    { country: 'Turkmenistan', code: '+993' },
    { country: 'Turks and Caicos Islands', code: '+1-649' },
    { country: 'Tuvalu', code: '+688' },
    { country: 'U.K', code: '+44' },
    { country: 'Uganda', code: '+256' },
    { country: 'Ukraine', code: '+380' },
    { country: 'United Arab Emirates', code: '+971' },
    { country: 'Uruguay', code: '+598' },
    { country: 'USA', code: '+1' },
    { country: 'Uzbekistan', code: '+998' },
    { country: 'Vanuatu', code: '+678' },
    { country: 'Vatican', code: '+39' },
    { country: 'Venezuela', code: '+58' },
    { country: 'Vietnam', code: '+84' },
    { country: 'Virgin Islands (British)', code: '+1-284' },
    { country: 'Virgin Islands (USA) +1-340' },
    { country: 'Wallis and Futuna Islands', code: '+681' },
    { country: 'Yemen', code: '+967' },
    { country: 'Zambia', code: '+260' },
    { country: 'Zimbabwe', code: '+263' }
  ];

  getCountryCode(number) {
    let code = ''
    const codes = this.countryCodes.map(item => item.code)
    if (codes.includes(number.slice(0, 2))) {
      code = number.slice(0, 2)
    }
    if (codes.includes(number.slice(0, 3))) {
      code = number.slice(0, 3)
    }
    if (codes.includes(number.slice(0, 4))) {
      code = number.slice(0, 4)
    }
    if (codes.includes(number.slice(0, 5))) {
      code = number.slice(0, 5)
    }
    if (codes.includes(number.slice(0, 6))) {
      code = number.slice(0, 6)
    }

    return code
  }

  addThumbnailField(studentArray) {
    let schoolStudents = JSON.parse(this.activeSchoolStudents);
    if (schoolStudents) {
      studentArray.forEach(element => {
        schoolStudents.forEach(student => {
          if (element.Student_Identifier == student.Student_Identifier) {
            element.Thumbnail = student.Thumbnail;
            element.Student_Image_S3_URL = student.Student_Image_S3_URL;
            return;
          }
        });
      });
    }

    return studentArray;
  }


  staffThumbnailField(staffArray) {
    let employees = JSON.parse(this.schoolEmployeesCache);
    if (employees) {
      staffArray.forEach(element => {
        employees.forEach(emp => {
          if (element.School_Employee_Identifier == emp.School_Employee_Identifier) {
            element.Thumbnail = emp.Thumbnail;
            element.Employee_Image_S3_URL = emp.Employee_Image_S3_URL;
            return;
          }
        });
      });
    }

    return staffArray;
  }


  getStudentThumbnail(id) {
    let student = JSON.parse(this.activeSchoolStudents).find(student => student.Student_Identifier === id);
    student.Student_Image_S3_URL = student.Student_Image_S3_URL == 'null' ? null : student.Student_Image_S3_URL;
    student.Student_Thumbnail_Image_S3_URL = student.Student_Thumbnail_Image_S3_URL == 'null' ? null : student.Student_Thumbnail_Image_S3_URL;

    if (student)
      return student.Student_Thumbnail_Image_S3_URL || student.Student_Image_S3_URL || '../../../../../assets/img/profile.png';
    else return '../../../../../assets/img/profile.png'
  }
  getStudentS3(id) {
    let student = JSON.parse(this.activeSchoolStudents).find(student => student.Student_Identifier === id);
    student.Student_Image_S3_URL = student.Student_Image_S3_URL == 'null' ? null : student.Student_Image_S3_URL;
    student.Student_Thumbnail_Image_S3_URL = student.Student_Thumbnail_Image_S3_URL == 'null' ? null : student.Student_Thumbnail_Image_S3_URL;

    if (student)
      return student.Student_Image_S3_URL;
    else return null
  }

  getLegalGuardianThumbnail(id) {
    const student = JSON.parse(this.duplicateSchoolStudents).find(student => student.Legal_Guardian_Identifier === id);
    if (student)
      return student.LG_Thumbnail_Image_S3_URL || student.LG_Image_S3_URL || '../../../../../assets/img/profile.png'
    else return '../../../../../assets/img/profile.png'
  }

  getLegalGuardianS3(id) {
    const student = JSON.parse(this.duplicateSchoolStudents).find(student => student.Legal_Guardian_Identifier === id);
    if (student)
      return student.LG_Image_S3_URL || '../../../../../assets/img/profile.png'
    else return '../../../../../assets/img/profile.png'
  }

  async simpleSearch(word: string, cols: any, list: any) {
    let newList = [];
    let wordsmall = word.toLowerCase();
    for (let index = 0; index < list.length; index++) {
      let element = list[index];

      for (let colInd = 0; colInd < cols.length; colInd++) {
        const column = cols[colInd];
        let colValue = element[column] ? element[column] : '';
        colValue = typeof colValue === 'string' ? colValue.toLowerCase() : colValue.toString();
        let smallword = colValue;
        if (smallword.includes(wordsmall)) {
          newList.push(element);
        }
      }
    }

    return newList;
  }

  public returnEnvironment() {
    var environ = window.location.protocol + "//" + window.location.host;
    return environ;
  }

  paymentIDroute;
  showPreFetchPrompt = true;
  async fetchPayment(studentID, cardExPaymentID) {
    // Fetch External Payment Record;
    this.showSpinner();
    let externalPaymentFetch = await this.httpGetAsync(`/mobile_payments?school_id=${this.school_id}&student_id=${studentID}&start_date=${this.getTheDate()}&end_date=${this.getTheDate()}` + this.getActivityForUrl("Financial Management", "Fetch Online Payments"));
    this.closeSpinner();

    if (externalPaymentFetch.status == 200) {
      
      let mobilePayments = Array.isArray(externalPaymentFetch.json()) ? externalPaymentFetch.json() : [];
      let theExPayment = mobilePayments.find(payment => payment.External_Payment_Identifier == cardExPaymentID);

      if (theExPayment) { // If External Payment Record exists
        this.showPreFetchPrompt = false;
        if (theExPayment.Student_Payment_General_Ledger_Identifier) {
          this.paymentIDroute = theExPayment.Student_Payment_General_Ledger_Identifier;
          // Fetch Payment History Record
          this.showSpinner('Loading Payment Record');
          let paymentFetch = await this.httpGetAsync(`/transaction/payment_history?school_id=${this.school_id}&student_id=${studentID}&start_date=${this.getTheDate()}&end_date=${this.getTheDate()}` + this.getActivityForUrl("Financial Management", "Fetch Payments"));
          this.closeSpinner();
          if (paymentFetch.status == 200) {
            let thePayment = paymentFetch.json().Students.find(payment => payment.General_Ledger_Identifier == theExPayment.Student_Payment_General_Ledger_Identifier);

            if (thePayment) { // If Payment History Record Exists

              // If PDF is generated
              if (thePayment.Bill_Payment_Receipt_S3_URL) {
                // this.openPDFpage(thePayment.Bill_Payment_Receipt_S3_URL);
                return { payment_id: this.paymentIDroute, pdf: thePayment.Bill_Payment_Receipt_S3_URL };
              } else {
                this.celebrate('Payment PDF is being generated, Try again after a little while');
              }
            } else {
              this.celebrate('Payment Not Found');
            }
          } else {
            this.handleErrorMessage(paymentFetch);
          }

        } else {
          this.celebrate('Payment transaction is being reconciled, Try again after a little while');
        }
      } else {
        this.celebrate('External transaction not found, Try again after a little while');
      }
    }
    else {
      this.handleErrorMessage(externalPaymentFetch);
    }
  }

  openPDFpage(thepdf: string) {
    open('https://www.idsurl.io/pdf-viewer/?url=' + thepdf);
  }

  searchShow(word: string, cols: any, list: any) {
    let wordsmall = word.toLowerCase();
    for (let index = 0; index < list.length; index++) {
      let element = list[index];
      element.show = false;
      for (let colInd = 0; colInd < cols.length; colInd++) {
        const column = cols[colInd];
        let smallword = element[column] ? element[column].toLowerCase() : '';
        if (smallword.includes(wordsmall)) {
          element.show = true;
        }
      }
    }


  }


  copyStringToClipboard(varString: string, message?: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = varString;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    message ? this.celebrate(message) : this.celebrate('Copied To Clipboard');
  }

  private apiUsers
  public getAppUser(listRec) {
    this.apiUsers = this.apiusersNames
    if (this.apiUsers) {
      return this.getAppReturns(listRec)
    } else {
      return listRec
    }
  }

  private getAppReturns(body): any {
    let data
    let toSend
    data = [...JSON.parse(this.apiUsers)]
    if (data.length && body.length) {
      for (let jh = 0; jh < body.length; jh++) {
        if (body[jh].Created_By) {
          let name2 = data.find(item => item.User_Identifier == body[jh].Created_By || item.User_Identifier.toString() == body[jh].Created_By)
          if (!name2) { body[jh] }
          else {

            body[jh].Created_Name = name2.First_Name + ' '
            name2.Middle_Name ? body[jh].Created_Name += name2.Middle_Name + ' ' + name2.Last_Name : body[jh].Created_Name += name2.Last_Name
            body[jh].Created_Short_Name = name2.First_Name + ' ' + name2.Last_Name
          }
        }
        if (body[jh].Updated_By) {
          let name = data.find(item => item.User_Identifier == body[jh].Updated_By || item.User_Identifier.toString() == body[jh].Updated_By)
          if (!name) { body[jh] }
          else {

            body[jh].Updated_Name = name.First_Name + ' '
            name.Middle_Name ? body[jh].Updated_Name += name.Middle_Name + ' ' + name.Last_Name : body[jh].Updated_Name += name.Last_Name
            body[jh].Updated_Short_Name = name.First_Name + ' ' + name.Last_Name
          }
        }
      }


    }
    return body
  }
  // End of Code



  //!!Search Student Uses BYRef method to search and return data to the screen
  /**
   *  @param stud_name Accepts the student name of the student that is being searched for
   *  @param Student_Id Accepts the student id of the student that is being searched for
   * @param status This should be the student Status (Active,Inactive).Default is Active
   */
  searchstudentVar = []
  public _sims = []
  txtSearchString: string = ''
  public searchStudent(stud_name: string, Student_Id?: Number, status?: string) {
    if (!status || status.toLowerCase() == 'active') {
      if (!this._sims.length) {
        this._sims = this.getClassname([...JSON.parse(this.activeSchoolStudents)])
      }

      if (stud_name.length) {
        this.searchstudentVar = this._sims.filter(std => std.Full_Name.toLowerCase().includes(stud_name.toLowerCase()))
      } else {
        this.searchstudentVar = []
      }
    }
  }

  getClassname(array) {
    const classess = [...JSON.parse(this.schoolClassroomsCache)]
    array.forEach(item => {
      if (classess.find(mainclass => mainclass.Classroom_Identifier == item.Classroom_Identifier)) {
        item.Classroom_Name_string = classess.find(mainclass => mainclass.Classroom_Identifier == item.Classroom_Identifier).Classroom_Name
      }
    })
    return array;
  }


  // Preview the Image on Full Screen Using Event Emitters
  imgPreview: MatDialogRef<ImgPreviewerComponent>
  ShowImgScreen(evt, url, name?, personObj?) {
    evt.stopPropagation()
    evt.preventDefault()
    if (url) {
      this.imgPreview = this.alertdialog.open(ImgPreviewerComponent, {
        width: "40vw",
        height: "80vh",
        panelClass: ['removeP', 'my-panel-class'],
        data: {
          id: personObj ? personObj.Student_Identifier || personObj.School_Employee_Identifier || personObj.Legal_Guardian_Identifier : null,
          url: url,
          oldurl: $(evt.currentTarget).attr('src'),
          Person_Name: name,
          // assInnerHTML: asInnerHTML
        }
      })
    } else {
      this.celebrate('No Profile Available')
    }
  }

  ConvertToCSV(objArray, filename?) {
    let value: any = []
    objArray.forEach(element => {
      delete element.isSel
    });
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    let str = `${Object.keys(array[0]).map(value => `${value}`).join(",")}` + '\r\n';

    var csvContent = array.reduce((str, next) => {
      str += `${Object.values(next).map(value => `${value + ''}`).join(",")}` + '\r\n';
      return str;
    }, str);
    const blob = new Blob([csvContent], { type: 'text/csv' })
    let dllink = document.createElement('a')
    dllink.href = window.URL.createObjectURL(blob);
    dllink.setAttribute("download", `${!filename ? this.school_name + ' - ' + this.getDateFormatted() : filename + '(' + this.school_name + ')-' + this.getDateFormatted()}.csv`);
    dllink.click();


    return value;
  }

  ConvertToExcel(objArray: any[], filename?: string) {
    objArray.forEach(element => {
      delete element.isSel;
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(objArray);

    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

    const excelFile = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });

    const buffer = new ArrayBuffer(excelFile.length);
    const view = new Uint8Array(buffer);
    for (let i = 0; i < excelFile.length; i++) {
      view[i] = excelFile.charCodeAt(i) & 0xFF;
    }

    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // Create a download link and trigger download
    const dllink = document.createElement('a');
    dllink.href = window.URL.createObjectURL(blob);
    dllink.setAttribute("download", `${filename || this.school_name + ' - ' + this.getDateFormatted()}.xlsx`);
    dllink.click();
  }

  FreePostUrl(url, body, fileUpload?) {
    return this.http.post(url, body, fileUpload ? this.returnRequestOptions2() : this.returnRequestOptions())

  }

  checkForCurrentAgreement(){
    let allAgreement = this.school_agreement ? [...JSON.parse(this.school_agreement)] : []
    if(!allAgreement.length) return [];
    const currentDate = new Date(); // Server current date

    let foundAgreement= allAgreement.filter(user => {
      const agreementDate = new Date(user.Agreement_Date);
      const expirationDate = new Date(user.Agreement_Expiration_Date);
  
      return currentDate >= agreementDate && currentDate <= expirationDate;
    })[0];

    if(foundAgreement){
      return [foundAgreement]
    }else{
      return [allAgreement[0]]
    }
  }

  checkAgreementAndTransactions(feature) {
    let schoolInfo = [];
    let currency = [];
    let activeAgreement:any = {}
    if (this.schoolCache) {
      schoolInfo = [...JSON.parse(this.schoolCache)]
    }
    if (this.schoolCurrenciesCache) {
      currency = [...JSON.parse(this.schoolCurrenciesCache)]
    }

    // Checking SchoolAgreementsList
    let allAgreements: any = this.checkForCurrentAgreement()
    let allPrepaidSerives: any = this.school_prepaid_services ? [...JSON.parse(this.school_prepaid_services)] : []

    //Filter prepaid services that have completed Transaction Status
    // allPrepaidSerives = allPrepaidSerives.filter(prepaid=>prepaid.Transaction_Status.toLowerCase()=="completed")

    if (!allAgreements.length) {
       activeAgreement['hit_paywall'] = false
       return activeAgreement
    } else {
      // remember to filter out pending records 
       // Sort the agreement by expiration date and bring the record that oldest date first.
      allPrepaidSerives = allPrepaidSerives.sort((a, b) => moment(a.Service_Expiration_Date).diff(moment(b.Service_Expiration_Date)));

      // Use agreement with the oldest expiration date
      let latestAgreement = allAgreements[0]

      //Check if the agreement is postpaid or prepaid
      const activePageClientID = this.resolveClientResourceID(feature);
      if (!activePageClientID) {
        this.celebrate('You are not authorized to access: ' + feature);
        return;
      }

      if(latestAgreement.Service_Base_Package_Type=="Prepaid"){
        // Check if the agreement is expired or not
          if(moment(latestAgreement.Service_Package_Expiration_Date).isSameOrBefore(moment(), 'day')){
            //Feature has expired soo now check the prepaid services
            const prepaidFeatureSearchExist = allPrepaidSerives.filter(services => services.Client_Application_Resource_Identifier == activePageClientID && !moment(services.Service_Expiration_Date).isSameOrBefore(moment(), 'day') && (services.Transaction_Status == "Completed" || services.Transaction_Status == "Pending") );
            if(prepaidFeatureSearchExist.length){
              let allmergedClasslist = prepaidFeatureSearchExist.map(item=>item.Prepaid_Service_Transaction_Classrooms.flat()).flat()
              let allmergedUser = prepaidFeatureSearchExist.map(item=>item.Prepaid_Service_Transaction_Users.flat()).flat()
              let singleMergedUser = prepaidFeatureSearchExist.find(item=>item.Transaction_Status=="Completed")
              if(singleMergedUser){
                singleMergedUser.Prepaid_Service_Transaction_Classrooms = allmergedClasslist
                singleMergedUser.Prepaid_Service_Transaction_Users = allmergedUser
              }else{
                singleMergedUser = prepaidFeatureSearchExist.find(item=>item.Transaction_Status=="Pending")
              }
              //Feature exist in pay soo check the expiration date
              if(moment(singleMergedUser.Service_Expiration_Date).isSameOrBefore(moment(), 'day')){
                // Feature has expired in prepaid service soo hit paywall
                activeAgreement = _.cloneDeep(latestAgreement)
                if (!activeAgreement['country']) {
                  const foundCurr = currency.find(item => item.Currency_Short_Symbol == activeAgreement.Invoice_Currency)
                  activeAgreement['country'] = schoolInfo[0].Country
                  activeAgreement['Invoice_Currency_Identifier'] = foundCurr ? foundCurr.Currency_Identifier : 221
                }
                activeAgreement['ActivePurchasedFeatures'] = allPrepaidSerives.filter(services=>!(moment(services.Service_Expiration_Date).isSameOrBefore(moment(), 'day')))
                 activeAgreement['hit_paywall'] = singleMergedUser.Transaction_Status.toLowerCase()=="completed"?true:null
                 activeAgreement['hit_modal'] = true
                 return activeAgreement
              }else{
                // Feature exist in prepaid and is not expired soo dont hit paywall
                 activeAgreement['hit_paywall'] = singleMergedUser.Transaction_Status.toLowerCase()=="completed"?false:null
                 activeAgreement['hit_modal'] = false
                 return activeAgreement
              }
            }else{
              //Feature doesnt exist in the prepaid services soo hit paywall
              activeAgreement = _.cloneDeep(latestAgreement)
              if (!activeAgreement['country']) {
                const foundCurr = currency.find(item => item.Currency_Short_Symbol == activeAgreement.Invoice_Currency)
                activeAgreement['country'] = schoolInfo[0].Country
                activeAgreement['Invoice_Currency_Identifier'] = foundCurr ? foundCurr.Currency_Identifier : 221
              }
               activeAgreement['ActivePurchasedFeatures'] = []
               activeAgreement['hit_paywall'] = true
               activeAgreement['hit_modal'] = true
               return activeAgreement
            }
           
          }else{
            // If Agreement isnt expired now check service package
            if(Array.isArray(latestAgreement.Service_Package_Client_Application_Resources)){ //Doing a check to see if the the key isnt a null or object incase if the school isnt linked to any packages doing this soo code doesnt break
              if(latestAgreement.Service_Package_Client_Application_Resources.length){ //Checking to see if the array has Client Resources
                //if the agreement has a list of client Ui's check if the UI is inside
                // const activePageClientID = this.resolveClientResourceID(feature)
                if(latestAgreement.Service_Package_Client_Application_Resources.find(clientid=>clientid.Client_Application_Resource_Identifier==activePageClientID)){
                  //if the feature is found do not hit the paywall
                   activeAgreement['hit_paywall'] = false
                   return activeAgreement
                }else{
                  //If feature wasnt found check the prepaid services if there is a record that isnt expired
                  const prepaidFeatureSearchExist = allPrepaidSerives.filter(services => services.Client_Application_Resource_Identifier == activePageClientID && !moment(services.Service_Expiration_Date).isSameOrBefore(moment(), 'day') && (services.Transaction_Status == "Completed" || services.Transaction_Status == "Pending") );
                  if(prepaidFeatureSearchExist.length){
                    let allmergedClasslist = prepaidFeatureSearchExist.map(item=>item.Prepaid_Service_Transaction_Classrooms.flat()).flat()
                    let allmergedUser = prepaidFeatureSearchExist.map(item=>item.Prepaid_Service_Transaction_Users.flat()).flat()
                    let singleMergedUser = prepaidFeatureSearchExist.find(item=>item.Transaction_Status=="Completed")
                    if(singleMergedUser){
                      singleMergedUser.Prepaid_Service_Transaction_Classrooms = allmergedClasslist
                      singleMergedUser.Prepaid_Service_Transaction_Users = allmergedUser
                    }else{
                      singleMergedUser = prepaidFeatureSearchExist.find(item=>item.Transaction_Status=="Pending")
                    }
                    //Feature exist in prepaid soo check the expiration date
                    if(moment(singleMergedUser.Service_Expiration_Date).isSameOrBefore(moment(), 'day')){
                      // Feature has expired in prepaid service soo hit paywall
                      activeAgreement = _.cloneDeep(latestAgreement)
                      if (!activeAgreement['country']) {
                        const foundCurr = currency.find(item => item.Currency_Short_Symbol == activeAgreement.Invoice_Currency)
                        activeAgreement['country'] = schoolInfo[0].Country
                        activeAgreement['Invoice_Currency_Identifier'] = foundCurr ? foundCurr.Currency_Identifier : null
                      }
                       activeAgreement['ActivePurchasedFeatures'] = latestAgreement.Service_Package_Client_Application_Resources
                       activeAgreement['hit_paywall'] = singleMergedUser.Transaction_Status.toLowerCase()=="completed"?true:null
                       return activeAgreement
                    }else{
                      // Feature exist in prepaid and is not expired soo dont hit paywall
                       activeAgreement['hit_paywall'] = singleMergedUser.Transaction_Status.toLowerCase()=="completed"?false:null
                       return activeAgreement
      
                    }
                  }else{
                    //Feature doesnt exist in the prepaid services soo hit paywall
                    activeAgreement = _.cloneDeep(latestAgreement)
                    if (!activeAgreement['country']) {
                      const foundCurr = currency.find(item => item.Currency_Short_Symbol == activeAgreement.Invoice_Currency)
                      activeAgreement['country'] = schoolInfo[0].Country
                      activeAgreement['Invoice_Currency_Identifier'] = foundCurr ? foundCurr.Currency_Identifier : null
                    }
                    activeAgreement['ActivePurchasedFeatures'] = [...latestAgreement.Service_Package_Client_Application_Resources,...allPrepaidSerives.filter(services=>!(moment(services.Service_Expiration_Date).isSameOrBefore(moment(), 'day')) && services.Transaction_Status=='Completed')]
                     activeAgreement['hit_paywall'] = true
                     return activeAgreement
                  }

                }
              }else{
                 activeAgreement['hit_paywall'] = false
                 return activeAgreement
              }
            }else{
               activeAgreement['hit_paywall'] = false
               return activeAgreement
            }
          }

      }else{
        //the Base is Postpaid dont check for expiration dates
            // If Agreement is postpaid now check service package
            if(Array.isArray(latestAgreement.Service_Package_Client_Application_Resources)){ //Doing a check to see if the the key isnt a null or object incase if the school isnt linked to any packages doing this soo code doesnt break
              if(latestAgreement.Service_Package_Client_Application_Resources.length){ //Checking to see if the array has Client Resources
                //if the agreement has a list of client Ui's check if the UI is inside
                // const activePageClientID = this.resolveClientResourceID(feature)
                if(latestAgreement.Service_Package_Client_Application_Resources.find(clientid=>clientid.Client_Application_Resource_Identifier==activePageClientID)){
                  //if the feature is found do not hit the paywall
                   activeAgreement['hit_paywall'] = false
                   return activeAgreement
                }else{
                  //If feature wasnt found check the postpaid services if there is a record
                  const prepaidFeatureSearchExist = allPrepaidSerives.filter(services => services.Client_Application_Resource_Identifier == activePageClientID && !moment(services.Service_Expiration_Date).isSameOrBefore(moment(), 'day') && (services.Transaction_Status == "Completed" || services.Transaction_Status == "Pending") );
                  if(prepaidFeatureSearchExist.length){
                    let allmergedClasslist = prepaidFeatureSearchExist.map(item=>item.Prepaid_Service_Transaction_Classrooms.flat()).flat()
                    let allmergedUser = prepaidFeatureSearchExist.map(item=>item.Prepaid_Service_Transaction_Users.flat()).flat()
                    let singleMergedUser = prepaidFeatureSearchExist.find(item=>item.Transaction_Status=="Completed")
                    if(singleMergedUser){
                      singleMergedUser.Prepaid_Service_Transaction_Classrooms = allmergedClasslist
                      singleMergedUser.Prepaid_Service_Transaction_Users = allmergedUser
                    }else{
                      singleMergedUser = prepaidFeatureSearchExist.find(item=>item.Transaction_Status=="Pending")
                    }
                    // if(moment(prepaidFeatureSearchExist.Service_Expiration_Date).isBefore(moment(), 'day')){}
                      // Feature exist in postpaid soo dont hit paywall
                       activeAgreement['hit_paywall'] = singleMergedUser.Transaction_Status.toLowerCase()=="completed"?false:null
                       return activeAgreement
      
                    
                  }else{
                    //Feature doesnt exist in the postpaid services soo hit paywall
                    activeAgreement = _.cloneDeep(latestAgreement)
                    if (!activeAgreement['country']) {
                      const foundCurr = currency.find(item => item.Currency_Short_Symbol == activeAgreement.Invoice_Currency)
                      activeAgreement['country'] = schoolInfo[0].Country
                      activeAgreement['Invoice_Currency_Identifier'] = foundCurr ? foundCurr.Currency_Identifier : null
                    }

                     activeAgreement['ActivePurchasedFeatures'] = [...latestAgreement.Service_Package_Client_Application_Resources,...allPrepaidSerives.filter(services=>!(moment(services.Service_Expiration_Date).isSameOrBefore(moment(), 'day')) && services.Transaction_Status=='Completed')]
                     activeAgreement['hit_paywall'] = true
                     return activeAgreement
                  }

                }
              }else{
                 activeAgreement['hit_paywall'] = false
                 return activeAgreement
              }
            }else{
               activeAgreement['hit_paywall'] = false
               return activeAgreement
            }
      }
    }

    // return activeAgreement
  }
}


// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/shared-data.service.ts